import { nanoid } from '@reduxjs/toolkit';
import carModelMakesData from './car_makes_models.json';

export const carModelMakesJson = carModelMakesData;
export const carModelMakes = [
  {
    id: nanoid(),
    label: 'AM General',
    value: 'AM General',
    model: [{ id: nanoid(), label: 'Hummer', value: 'Hummer' }],
  },
  {
    id: nanoid(),
    label: 'Acura',
    value: 'Acura',
    model: [
      { id: nanoid(), label: 'EL', value: 'EL' },
      { id: nanoid(), label: 'Integra', value: 'Integra' },
      { id: nanoid(), label: 'Legend', value: 'Legend' },
    ],
  },
  {
    id: nanoid(),
    label: 'Alfa Romeo',
    value: 'Alfa Romeo',
    model: [
      { id: nanoid(), label: '8C Competizione', value: '8C Competizione' },
      { id: nanoid(), label: 'Spider', value: 'Spider' },
      { id: nanoid(), label: 'Stelvio', value: 'Stelvio' },
      { id: nanoid(), label: 'Tonale', value: 'Tonale' },
      { id: nanoid(), label: 'Veloce', value: 'Veloce' },
    ],
  },
  {
    id: nanoid(),
    label: 'Aston Martin',
    value: 'Aston Martin',
    model: [
      { id: nanoid(), label: 'DBS Superleggera', value: 'DBS Superleggera' },
      { id: nanoid(), label: 'Rapide', value: 'Rapide' },
      { id: nanoid(), label: 'Roadster', value: 'Roadster' },
      { id: nanoid(), label: 'V12 Vantage', value: 'V12 Vantage' },
      { id: nanoid(), label: 'V8 Vantage', value: 'V8 Vantage' },
      {
        id: nanoid(),
        label: 'V8 Vantage Roadster',
        value: 'V8 Vantage Roadster',
      },
      {
        id: nanoid(),
        label: 'V8 Vantage Roadster SPORTSHIFT',
        value: 'V8 Vantage Roadster SPORTSHIFT',
      },
      {
        id: nanoid(),
        label: 'V8 Vantage SPORTSHIFT',
        value: 'V8 Vantage SPORTSHIFT',
      },
      { id: nanoid(), label: 'Vantage', value: 'Vantage' },
      { id: nanoid(), label: 'Virage', value: 'Virage' },
    ],
  },
  {
    id: nanoid(),
    label: 'Audi',
    value: 'Audi',
    model: [
      { id: nanoid(), label: 'e-tron', value: 'e-tron' },
      { id: nanoid(), label: 'e-tron GT', value: 'e-tron GT' },
      { id: nanoid(), label: 'e-tron S', value: 'e-tron S' },
      {
        id: nanoid(),
        label: 'e-tron S Sportback',
        value: 'e-tron S Sportback',
      },
      { id: nanoid(), label: 'e-tron Sportback', value: 'e-tron Sportback' },
      { id: nanoid(), label: 'A3 Cabriolet', value: 'A3 Cabriolet' },
      { id: nanoid(), label: 'A3 Sedan', value: 'A3 Sedan' },
      {
        id: nanoid(),
        label: 'A3 Sportback e-tron',
        value: 'A3 Sportback e-tron',
      },
      { id: nanoid(), label: 'A5 Cabriolet', value: 'A5 Cabriolet' },
      { id: nanoid(), label: 'A5 Coupe', value: 'A5 Coupe' },
      { id: nanoid(), label: 'Cabriolet', value: 'Cabriolet' },
      { id: nanoid(), label: 'Coupe', value: 'Coupe' },
      {
        id: nanoid(),
        label: 'Q1',
        value: 'Q1',
      },
      {
        id: nanoid(),
        label: 'Q4 Sportback e-tron',
        value: 'Q4 Sportback e-tron',
      },
      { id: nanoid(), label: 'Q4 e-tron', value: 'Q4 e-tron' },
      {
        id: nanoid(),
        label: 'Q8 Sportback e-tron',
        value: 'Q8 Sportback e-tron',
      },
      { id: nanoid(), label: 'Q8 e-tron', value: 'Q8 e-tron' },
      { id: nanoid(), label: 'RS 5 Cabriolet', value: 'RS 5 Cabriolet' },
      { id: nanoid(), label: 'RS 5 Coupe', value: 'RS 5 Coupe' },
      { id: nanoid(), label: 'RS e-tron GT', value: 'RS e-tron GT' },
      { id: nanoid(), label: 'S5 Cabriolet', value: 'S5 Cabriolet' },
      { id: nanoid(), label: 'S5 Coupe', value: 'S5 Coupe' },
      {
        id: nanoid(),
        label: 'SQ8 Sportback e-tron',
        value: 'SQ8 Sportback e-tron',
      },
      { id: nanoid(), label: 'SQ8 e-tron', value: 'SQ8 e-tron' },
      { id: nanoid(), label: 'TT Coupe', value: 'TT Coupe' },
      { id: nanoid(), label: 'TT Roadster', value: 'TT Roadster' },
      { id: nanoid(), label: 'TTS Coupe', value: 'TTS Coupe' },
    ],
  },
  {
    id: nanoid(),
    label: 'BMW',
    value: 'BMW',
    model: [
      { id: nanoid(), label: '1 Series', value: '1 Series' },
      { id: nanoid(), label: '2 Series', value: '2 Series' },
      { id: nanoid(), label: '3 Series', value: '3 Series' },
      { id: nanoid(), label: '4 Series', value: '4 Series' },
      { id: nanoid(), label: '5 Series', value: '5 Series' },
      { id: nanoid(), label: '530i', value: '530i' },
      { id: nanoid(), label: '6 Series', value: '6 Series' },
      {
        id: nanoid(),
        label: '6 Series Convertible',
        value: '6 Series Convertible',
      },
      { id: nanoid(), label: '6 Series Coupe', value: '6 Series Coupe' },
      {
        id: nanoid(),
        label: '6 Series Gran Coupe',
        value: '6 Series Gran Coupe',
      },
      {
        id: nanoid(),
        label: '6 Series Gran Turismo',
        value: '6 Series Gran Turismo',
      },
      { id: nanoid(), label: '7 Series', value: '7 Series' },
      { id: nanoid(), label: '740', value: '740' },
      { id: nanoid(), label: '8 Series', value: '8 Series' },
      {
        id: nanoid(),
        label: 'ALPINA B6 Gran Coupe',
        value: 'ALPINA B6 Gran Coupe',
      },
      {
        id: nanoid(),
        label: 'Alpina XB7',
        value: 'Alpina XB7',
      },
      { id: nanoid(), label: 'Convertible', value: 'Convertible' },
      { id: nanoid(), label: 'M Series', value: 'M Series' },
      { id: nanoid(), label: 'M2 Coupe', value: 'M2 Coupe' },
      { id: nanoid(), label: 'M3 Sedan', value: 'M3 Sedan' },
      { id: nanoid(), label: 'M4', value: 'M4' },
      { id: nanoid(), label: 'M4 Convertible', value: 'M4 Convertible' },
      { id: nanoid(), label: 'M4 Coupe', value: 'M4 Coupe' },
      { id: nanoid(), label: 'M5 Sedan', value: 'M5 Sedan' },
      { id: nanoid(), label: 'M6 Convertible', value: 'M6 Convertible' },
      { id: nanoid(), label: 'M6 Coupe', value: 'M6 Coupe' },
      { id: nanoid(), label: 'M6 Gran Coupe', value: 'M6 Gran Coupe' },
      { id: nanoid(), label: 'M8 Convertible', value: 'M8 Convertible' },
      { id: nanoid(), label: 'M8 Coupe', value: 'M8 Coupe' },
      { id: nanoid(), label: 'M8 Gran Coupe', value: 'M8 Gran Coupe' },
      { id: nanoid(), label: 'Roadster', value: 'Roadster' },
      { id: nanoid(), label: 'X1', value: 'X1' },
      { id: nanoid(), label: 'X5 M60i', value: 'X5 M60i' },
    ],
  },
  {
    id: nanoid(),
    label: 'Bentley',
    value: 'Bentley',
    model: [
      { id: nanoid(), label: 'Arnage', value: 'Arnage' },
      { id: nanoid(), label: 'Azure', value: 'Azure' },
      { id: nanoid(), label: 'Bentayga', value: 'Bentayga' },
      { id: nanoid(), label: 'Continental', value: 'Continental' },
      {
        id: nanoid(),
        label: 'Continental Flying Spur',
        value: 'Continental Flying Spur',
      },
      { id: nanoid(), label: 'Continental GT', value: 'Continental GT' },
      { id: nanoid(), label: 'Continental GTC', value: 'Continental GTC' },
      {
        id: nanoid(),
        label: 'Continental Supersports',
        value: 'Continental Supersports',
      },
      { id: nanoid(), label: 'Mulsanne', value: 'Mulsanne' },
    ],
  },
  {
    id: nanoid(),
    label: 'Buick',
    value: 'Buick',
    model: [
      { id: nanoid(), label: 'Electra', value: 'Electra' },
      { id: nanoid(), label: 'Enclave', value: 'Enclave' },
      { id: nanoid(), label: 'Encore', value: 'Encore' },
      { id: nanoid(), label: 'Encore GX', value: 'Encore GX' },
      { id: nanoid(), label: 'Envision', value: 'Envision' },
      { id: nanoid(), label: 'Envista', value: 'Envista' },
      { id: nanoid(), label: 'Allure', value: 'Allure' },
      { id: nanoid(), label: 'Century', value: 'Century' },
      { id: nanoid(), label: 'LaCrosse', value: 'LaCrosse' },
      { id: nanoid(), label: 'LeSabre', value: 'LeSabre' },
      { id: nanoid(), label: 'Lucerne', value: 'Lucerne' },
      { id: nanoid(), label: 'Park Avenue', value: 'Park Avenue' },
      { id: nanoid(), label: 'Rainier', value: 'Rainier' },
      { id: nanoid(), label: 'Reatta', value: 'Reatta' },
      { id: nanoid(), label: 'Regal', value: 'Regal' },
      { id: nanoid(), label: 'Regal Sportback', value: 'Regal Sportback' },
      { id: nanoid(), label: 'Regal TourX', value: 'Regal TourX' },
      { id: nanoid(), label: 'Rendezvous', value: 'Rendezvous' },
      { id: nanoid(), label: 'Riviera', value: 'Riviera' },
      { id: nanoid(), label: 'Roadmaster', value: 'Roadmaster' },
      { id: nanoid(), label: 'Terraza', value: 'Terraza' },
      { id: nanoid(), label: 'Verano', value: 'Verano' },
    ],
  },
  {
    id: nanoid(),
    label: 'Cadillac',
    value: 'Cadillac',
    model: [
      { id: nanoid(), label: 'ELR', value: 'ELR' },
      { id: nanoid(), label: 'Eldorado', value: 'Eldorado' },
      { id: nanoid(), label: 'Escalade', value: 'Escalade' },
      { id: nanoid(), label: 'Escalade ESV', value: 'Escalade ESV' },
      { id: nanoid(), label: 'Escalade EXT', value: 'Escalade EXT' },
      { id: nanoid(), label: 'ATS Coupe', value: 'ATS Coupe' },
      { id: nanoid(), label: 'ATS Sedan', value: 'ATS Sedan' },
      { id: nanoid(), label: 'ATS-V Coupe', value: 'ATS-V Coupe' },
      { id: nanoid(), label: 'ATS-V Sedan', value: 'ATS-V Sedan' },
      { id: nanoid(), label: 'Allante', value: 'Allante' },
      { id: nanoid(), label: 'CTS Coupe', value: 'CTS Coupe' },
      { id: nanoid(), label: 'CTS Sedan', value: 'CTS Sedan' },
      { id: nanoid(), label: 'CTS Sport Sedan', value: 'CTS Sport Sedan' },
      { id: nanoid(), label: 'CTS-V Coupe', value: 'CTS-V Coupe' },
      { id: nanoid(), label: 'CTS-V Sedan', value: 'CTS-V Sedan' },
      { id: nanoid(), label: 'CTS-V Sport Sedan', value: 'CTS-V Sport Sedan' },
      { id: nanoid(), label: 'Catera', value: 'Catera' },
      { id: nanoid(), label: 'DeVille', value: 'DeVille' },
      { id: nanoid(), label: 'Fleetwood', value: 'Fleetwood' },
      {
        id: nanoid(),
        label: 'Professional Chassis',
        value: 'Professional Chassis',
      },
      { id: nanoid(), label: 'Seville', value: 'Seville' },
      { id: nanoid(), label: 'Sixty Special', value: 'Sixty Special' },
    ],
  },
  {
    id: nanoid(),
    label: 'Chevrolet',
    value: 'Chevrolet',
    model: [
      { id: nanoid(), label: 'Bolt', value: 'Bolt' },
      { id: nanoid(), label: 'El Camino', value: 'El Camino' },
      { id: nanoid(), label: 'Equinox', value: 'Equinox' },
      { id: nanoid(), label: 'Equinox EV', value: 'Equinox EV' },
      { id: nanoid(), label: 'Express', value: 'Express' },
      { id: nanoid(), label: 'Express Cargo', value: 'Express Cargo' },
      { id: nanoid(), label: 'Express Cutaway', value: 'Express Cutaway' },
      { id: nanoid(), label: 'Express G1500', value: 'Express G1500' },
      { id: nanoid(), label: 'Express G2500', value: 'Express G2500' },
      { id: nanoid(), label: 'Express G3500', value: 'Express G3500' },
      { id: nanoid(), label: 'Express G4500', value: 'Express G4500' },
      { id: nanoid(), label: 'Express Passenger', value: 'Express Passenger' },
      { id: nanoid(), label: 'Astro Passenger', value: 'Astro Passenger' },
      { id: nanoid(), label: 'Avalanche', value: 'Avalanche' },
      { id: nanoid(), label: 'Aveo', value: 'Aveo' },
      { id: nanoid(), label: 'Aveo5', value: 'Aveo5' },
      { id: nanoid(), label: 'Beretta', value: 'Beretta' },
      { id: nanoid(), label: 'Blazer', value: 'Blazer' },
      { id: nanoid(), label: 'Blazer EV', value: 'Blazer EV' },
      { id: nanoid(), label: 'Bolt EUV', value: 'Bolt EUV' },
      { id: nanoid(), label: 'Bolt EV', value: 'Bolt EV' },
      { id: nanoid(), label: 'C series', value: 'C series' },
      { id: nanoid(), label: 'Caprice', value: 'Caprice' },
      { id: nanoid(), label: 'Caprice/Impala', value: 'Caprice/Impala' },
      { id: nanoid(), label: 'Cavalier', value: 'Cavalier' },
      { id: nanoid(), label: 'Celebrity', value: 'Celebrity' },
      { id: nanoid(), label: 'Chevette', value: 'Chevette' },
      { id: nanoid(), label: 'Chevy Van', value: 'Chevy Van' },
      { id: nanoid(), label: 'City Express', value: 'City Express' },
      { id: nanoid(), label: 'Classic Silverado', value: 'Classic Silverado' },
      { id: nanoid(), label: 'Corvette', value: 'Corvette' },
      { id: nanoid(), label: 'Corvette Stingray', value: 'Corvette Stingray' },
      { id: nanoid(), label: 'Cruze', value: 'Cruze' },
      { id: nanoid(), label: 'Cruze Limited', value: 'Cruze Limited' },
      { id: nanoid(), label: 'Geo Prizm', value: 'Geo Prizm' },
      { id: nanoid(), label: 'Geo Sprint', value: 'Geo Sprint' },
      { id: nanoid(), label: 'Impala Limited', value: 'Impala Limited' },
      { id: nanoid(), label: 'ME6500', value: 'ME6500' },
      { id: nanoid(), label: 'Malibu Limited', value: 'Malibu Limited' },
      { id: nanoid(), label: 'Metro', value: 'Metro' },
      { id: nanoid(), label: 'Monte Carlo', value: 'Monte Carlo' },
      { id: nanoid(), label: 'Silverado', value: 'Silverado' },
      { id: nanoid(), label: 'Silverado 1500', value: 'Silverado 1500' },
      { id: nanoid(), label: 'Silverado 1500 LD', value: 'Silverado 1500 LD' },
      {
        id: nanoid(),
        label: 'Silverado 1500 Limited',
        value: 'Silverado 1500 Limited',
      },
      { id: nanoid(), label: 'Silverado 1500HD', value: 'Silverado 1500HD' },
      { id: nanoid(), label: 'Silverado 2500', value: 'Silverado 2500' },
      { id: nanoid(), label: 'Silverado 2500HD', value: 'Silverado 2500HD' },
      { id: nanoid(), label: 'Silverado 3500', value: 'Silverado 3500' },
      {
        id: nanoid(),
        label: 'Silverado 3500 Chassis Cab',
        value: 'Silverado 3500 Chassis Cab',
      },
      { id: nanoid(), label: 'Silverado 3500HD', value: 'Silverado 3500HD' },
      {
        id: nanoid(),
        label: 'Silverado 4500 Medium Duty Chassis Cab',
        value: 'Silverado 4500 Medium Duty Chassis Cab',
      },
      { id: nanoid(), label: 'Tahoe LS', value: 'Tahoe LS' },
    ],
  },
  {
    id: nanoid(),
    label: 'Chrysler',
    value: 'Chrysler',
    model: [
      { id: nanoid(), label: 'Aspen', value: 'Aspen' },
      { id: nanoid(), label: 'Concorde', value: 'Concorde' },
      { id: nanoid(), label: 'Conquest', value: 'Conquest' },
      { id: nanoid(), label: 'Crossfire', value: 'Crossfire' },
      { id: nanoid(), label: 'Fifth Ave', value: 'Fifth Ave' },
      { id: nanoid(), label: 'Grand Voyager', value: 'Grand Voyager' },
      { id: nanoid(), label: 'Imperial', value: 'Imperial' },
      { id: nanoid(), label: 'Intrepid', value: 'Intrepid' },
      { id: nanoid(), label: 'Laser', value: 'Laser' },
      { id: nanoid(), label: 'Lebaron', value: 'Lebaron' },
      { id: nanoid(), label: 'New Yorker', value: 'New Yorker' },
      { id: nanoid(), label: 'PT Cruiser', value: 'PT Cruiser' },
      { id: nanoid(), label: 'Pacifica PHEV', value: 'Pacifica PHEV' },
      { id: nanoid(), label: 'Prowler', value: 'Prowler' },
      { id: nanoid(), label: 'Sebring', value: 'Sebring' },
      { id: nanoid(), label: 'Voyager', value: 'Voyager' },
    ],
  },
  {
    id: nanoid(),
    label: 'Dodge',
    value: 'Dodge',
    model: [
      { id: nanoid(), label: 'Aries', value: 'Aries' },
      { id: nanoid(), label: 'Avenger', value: 'Avenger' },
      { id: nanoid(), label: 'Caliber', value: 'Caliber' },
      { id: nanoid(), label: 'Challenger', value: 'Challenger' },
      { id: nanoid(), label: 'Charger', value: 'Charger' },
      { id: nanoid(), label: 'D series', value: 'D series' },
      { id: nanoid(), label: 'Hornet', value: 'Hornet' },
      { id: nanoid(), label: 'Intrepid', value: 'Intrepid' },
      { id: nanoid(), label: 'Journey', value: 'Journey' },
      { id: nanoid(), label: 'Neon', value: 'Neon' },
      { id: nanoid(), label: 'Raider', value: 'Raider' },
      { id: nanoid(), label: 'Ramcharger', value: 'Ramcharger' },
      { id: nanoid(), label: 'Rampage', value: 'Rampage' },
      { id: nanoid(), label: 'Shelby', value: 'Shelby' },
      { id: nanoid(), label: 'Sprinter', value: 'Sprinter' },
      { id: nanoid(), label: 'Sprinter Van', value: 'Sprinter Van' },
      { id: nanoid(), label: 'Sprinter Wagon', value: 'Sprinter Wagon' },
      { id: nanoid(), label: 'Stealth', value: 'Stealth' },
      { id: nanoid(), label: 'Viper', value: 'Viper' },
      { id: nanoid(), label: 'W series', value: 'W series' },
    ],
  },
  {
    id: nanoid(),
    label: 'FIAT',
    value: 'FIAT',
    model: [
      { id: nanoid(), label: '124 Spider', value: '124 Spider' },
      { id: nanoid(), label: '500e', value: '500e' },
      { id: nanoid(), label: 'Bertone', value: 'Bertone' },
    ],
  },
  {
    id: nanoid(),
    label: 'Ferrari',
    value: 'Ferrari',
    model: [
      { id: nanoid(), label: 'Enzo', value: 'Enzo' },
      { id: nanoid(), label: '458 Speciale', value: '458 Speciale' },
      { id: nanoid(), label: '458 Spider', value: '458 Spider' },
      { id: nanoid(), label: '488 Pista Spider', value: '488 Pista Spider' },
      { id: nanoid(), label: '488 Spider', value: '488 Spider' },
      { id: nanoid(), label: '550 Maranello', value: '550 Maranello' },
      { id: nanoid(), label: '575M Maranello', value: '575M Maranello' },
      { id: nanoid(), label: '812 Competizione', value: '812 Competizione' },
      { id: nanoid(), label: 'F12berlinetta', value: 'F12berlinetta' },
      { id: nanoid(), label: 'LaFerrari', value: 'LaFerrari' },
      { id: nanoid(), label: 'SF90 Spider', value: 'SF90 Spider' },
      { id: nanoid(), label: 'Superamerica', value: 'Superamerica' },
      { id: nanoid(), label: 'Testarossa', value: 'Testarossa' },
    ],
  },
  {
    id: nanoid(),
    label: 'Fisker',
    value: 'Fisker',
    model: [{ id: nanoid(), label: 'Ocean', value: 'Ocean' }],
  },
  {
    id: nanoid(),
    label: 'Ford',
    value: 'Ford',
    model: [
      { id: nanoid(), label: 'Bronco', value: 'Bronco' },
      {
        id: nanoid(),
        label: 'E-Series Econoline Van',
        value: 'E-Series Econoline Van',
      },
      {
        id: nanoid(),
        label: 'E-Series Econoline Wagon',
        value: 'E-Series Econoline Wagon',
      },
      { id: nanoid(), label: 'E-Series Van', value: 'OceE-Series Vanan' },
      { id: nanoid(), label: 'E-Series Wagon', value: 'E-Series Wagon' },
      { id: nanoid(), label: 'EcoSport', value: 'EcoSport' },
      { id: nanoid(), label: 'Econoline', value: 'Econoline' },
      { id: nanoid(), label: 'Econoline Van', value: 'Econoline Van' },
      { id: nanoid(), label: 'Econoline Wagon', value: 'Econoline Wagon' },
      { id: nanoid(), label: 'Edge', value: 'Edge' },
      { id: nanoid(), label: 'Escape', value: 'Escape' },
      { id: nanoid(), label: 'Escort', value: 'Escort' },
      { id: nanoid(), label: 'Excursion', value: 'Excursion' },
      { id: nanoid(), label: 'Expedition', value: 'Expedition' },
      { id: nanoid(), label: 'Expedition MAX', value: 'Expedition MAX' },
      { id: nanoid(), label: 'Explorer', value: 'Explorer' },
      { id: nanoid(), label: 'Explorer Sport', value: 'Explorer Sport' },
      {
        id: nanoid(),
        label: 'Explorer Sport Trac',
        value: 'Explorer Sport Trac',
      },
      { id: nanoid(), label: 'Aerostar', value: 'Aerostar' },
      { id: nanoid(), label: 'C series', value: 'C series' },
      { id: nanoid(), label: 'F-150 Heritage', value: 'F-150 Heritage' },
      { id: nanoid(), label: 'F-250 Super Duty', value: 'F-250 Super Duty' },
      { id: nanoid(), label: 'F-350 Super Duty', value: 'F-350 Super Duty' },
      {
        id: nanoid(),
        label: 'F-350 Super Duty Chassis Cab',
        value: 'F-350 Super Duty Chassis Cab',
      },
      { id: nanoid(), label: 'F-450 Super Duty', value: 'F-450 Super Duty' },
      {
        id: nanoid(),
        label: 'F-450 Super Duty Chassis Cab',
        value: 'F-450 Super Duty Chassis Cab',
      },
      {
        id: nanoid(),
        label: 'F-550 Super Duty Chassis Cab',
        value: 'F-550 Super Duty Chassis Cab',
      },
      { id: nanoid(), label: 'Festiva', value: 'Festiva' },
      { id: nanoid(), label: 'Fiesta', value: 'Fiesta' },
      { id: nanoid(), label: 'Five Hundred', value: 'Five Hundred' },
      { id: nanoid(), label: 'Flex', value: 'Flex' },
      { id: nanoid(), label: 'Freestar', value: 'Freestar' },
      { id: nanoid(), label: 'Freestyle', value: 'Freestyle' },
      { id: nanoid(), label: 'Fusion Energi', value: 'Fusion Energi' },
      { id: nanoid(), label: 'H series', value: 'H series' },
      { id: nanoid(), label: 'Maverick', value: 'Maverick' },
      { id: nanoid(), label: 'Motorhome Chassis', value: 'Motorhome Chassis' },
      { id: nanoid(), label: 'Mustang', value: 'Mustang' },
      { id: nanoid(), label: 'Mustang Mach-E', value: 'Mustang Mach-E' },
      { id: nanoid(), label: 'N series', value: 'N series' },
      { id: nanoid(), label: 'Probe', value: 'Probe' },
      { id: nanoid(), label: 'Ranger', value: 'Ranger' },
      { id: nanoid(), label: 'Tempo', value: 'Tempo' },
      { id: nanoid(), label: 'Think Neighbor', value: 'Think Neighbor' },
      { id: nanoid(), label: 'Thunderbird', value: 'Thunderbird' },
      { id: nanoid(), label: 'Transit Connect', value: 'Transit Connect' },
      {
        id: nanoid(),
        label: 'Transit Connect Van',
        value: 'Transit Connect Van',
      },
      {
        id: nanoid(),
        label: 'Transit Connect Wagon',
        value: 'Transit Connect Wagon',
      },
      { id: nanoid(), label: 'Transit Crew Van', value: 'Transit Crew Van' },
      {
        id: nanoid(),
        label: 'Transit Passenger Van',
        value: 'Transit Passenger Van',
      },
    ],
  },
  {
    id: nanoid(),
    label: 'GMC',
    value: 'GMC',
    model: [
      { id: nanoid(), label: 'Envoy', value: 'Envoy' },
      { id: nanoid(), label: 'Envoy XL', value: 'Envoy XL' },
      { id: nanoid(), label: 'Envoy XUV', value: 'Envoy XUV' },
      { id: nanoid(), label: 'Acadia Limited', value: 'Acadia Limited' },
      { id: nanoid(), label: 'C series', value: 'C series' },
      { id: nanoid(), label: 'Caballero', value: 'Caballero' },
      { id: nanoid(), label: 'Classic Sierra', value: 'Classic Sierra' },
      { id: nanoid(), label: 'Geo Tracker', value: 'Geo Tracker' },
      { id: nanoid(), label: 'HUMMER EV', value: 'HUMMER EV' },
      { id: nanoid(), label: 'ME6500', value: 'ME6500' },
      { id: nanoid(), label: 'R15 Conventional', value: 'R15 Conventional' },
      { id: nanoid(), label: 'R25 Conventional', value: 'R25 Conventional' },
      { id: nanoid(), label: 'R35 Conventional', value: 'R35 Conventional' },
      { id: nanoid(), label: 'Savana Passenger', value: 'Savana Passenger' },
      { id: nanoid(), label: 'Sierra', value: 'Sierra' },
      { id: nanoid(), label: 'Sierra 1500', value: 'Sierra 1500' },
      {
        id: nanoid(),
        label: 'Sierra 1500 Denali',
        value: 'Sierra 1500 Denali',
      },
      {
        id: nanoid(),
        label: 'Sierra 1500 Limited',
        value: 'Sierra 1500 Limited',
      },
      { id: nanoid(), label: 'Sierra 1500HD', value: 'Sierra 1500HD' },
      { id: nanoid(), label: 'Sierra 2500', value: 'Sierra 2500' },
      {
        id: nanoid(),
        label: 'Sierra 2500 Denali HD',
        value: 'Sierra 2500 Denali HD',
      },
      { id: nanoid(), label: 'Sierra 2500HD', value: 'Sierra 2500HD' },
      { id: nanoid(), label: 'Sierra 3500', value: 'Sierra 3500' },
      {
        id: nanoid(),
        label: 'Sierra 3500 Chassis Cab',
        value: 'Sierra 3500 Chassis Cab',
      },
      {
        id: nanoid(),
        label: 'Sierra 3500 Denali HD',
        value: 'Sierra 3500 Denali HD',
      },
      { id: nanoid(), label: 'Sierra 3500HD', value: 'Sierra 3500HD' },
      {
        id: nanoid(),
        label: 'Sierra Classic 1500',
        value: 'Sierra Classic 1500',
      },
      {
        id: nanoid(),
        label: 'Sierra Classic 2500HD',
        value: 'Sierra Classic 2500HD',
      },
      {
        id: nanoid(),
        label: 'Sierra Classic 3500',
        value: 'Sierra Classic 3500',
      },
      {
        id: nanoid(),
        label: 'Sierra Classic 3500 Chassis Cab',
        value: 'Sierra Classic 3500 Chassis Cab',
      },
      {
        id: nanoid(),
        label: 'Sierra Classic Denali',
        value: 'Sierra Classic Denali',
      },
      {
        id: nanoid(),
        label: 'Sierra Limited 1500',
        value: 'Sierra Limited 1500',
      },
      { id: nanoid(), label: 'Syclone', value: 'Syclone' },
      { id: nanoid(), label: 'T-Series', value: 'T-Series' },
      { id: nanoid(), label: 'Terrain', value: 'Terrain' },
      { id: nanoid(), label: 'V15 Conventional', value: 'V15 Conventional' },
      { id: nanoid(), label: 'V25 Conventional', value: 'V25 Conventional' },
      { id: nanoid(), label: 'V35 Conventional', value: 'V35 Conventional' },
      { id: nanoid(), label: 'Value Van', value: 'Value Van' },
    ],
  },
  {
    id: nanoid(),
    label: 'Genesis',
    value: 'Genesis',
    model: [
      { id: nanoid(), label: 'Electrified G80', value: 'Electrified G80' },
    ],
  },
  {
    id: nanoid(),
    label: 'Geo',
    value: 'Geo',
    model: [
      { id: nanoid(), label: 'Metro', value: 'Metro' },
      { id: nanoid(), label: 'Tracker', value: 'Tracker' },
    ],
  },
  {
    id: nanoid(),
    label: 'Honda',
    value: 'Honda',
    model: [
      { id: nanoid(), label: 'ES', value: 'ES' },
      { id: nanoid(), label: 'Element', value: 'Element' },
      { id: nanoid(), label: 'Accord', value: 'Accord' },
      { id: nanoid(), label: 'Accord Coupe', value: 'Accord Coupe' },
      { id: nanoid(), label: 'Accord Sedan', value: 'Accord Sedan' },
      { id: nanoid(), label: 'Civic Coupe', value: 'Civic Coupe' },
      { id: nanoid(), label: 'Civic Sedan', value: 'Civic Sedan' },
      { id: nanoid(), label: 'Civic Type R', value: 'Civic Type R' },
      { id: nanoid(), label: 'Del Sol', value: 'Del Sol' },
      { id: nanoid(), label: 'Odyssey', value: 'Odyssey' },
      { id: nanoid(), label: 'Prelude', value: 'Prelude' },
      { id: nanoid(), label: 'Prologue', value: 'Prologue' },
      { id: nanoid(), label: 'Ridgeline', value: 'Ridgeline' },
    ],
  },
  {
    id: nanoid(),
    label: 'Hyundai',
    value: 'Hyundai',
    model: [
      { id: nanoid(), label: 'Elantra', value: 'Elantra' },
      { id: nanoid(), label: 'Elantra Coupe', value: 'Elantra Coupe' },
      { id: nanoid(), label: 'Elantra GT', value: 'Elantra GT' },
      { id: nanoid(), label: 'Elantra N', value: 'Elantra N' },
      { id: nanoid(), label: 'Elantra Sedan', value: 'Elantra Sedan' },
      { id: nanoid(), label: 'Elantra Sport', value: 'Elantra Sport' },
      { id: nanoid(), label: 'Elantra Touring', value: 'Elantra Touring' },
      { id: nanoid(), label: 'Entourage', value: 'Entourage' },
      { id: nanoid(), label: 'Equus', value: 'Equus' },
      { id: nanoid(), label: 'Accent', value: 'Accent' },
      { id: nanoid(), label: 'Accent Hatchback', value: 'Accent Hatchback' },
      { id: nanoid(), label: 'Accent Sedan', value: 'Accent Sedan' },
      { id: nanoid(), label: 'Azera', value: 'Azera' },
      { id: nanoid(), label: 'Genesis', value: 'Genesis' },
      { id: nanoid(), label: 'Genesis Coupe', value: 'Genesis Coupe' },
      { id: nanoid(), label: 'Kona EV', value: 'Kona EV' },
      { id: nanoid(), label: 'Nexo', value: 'Nexo' },
      { id: nanoid(), label: 'Palisade', value: 'Palisade' },
      { id: nanoid(), label: 'Santa Cruz', value: 'Santa Cruz' },
      { id: nanoid(), label: 'Santa Fe', value: 'Santa Fe' },
      { id: nanoid(), label: 'Santa Fe Sport', value: 'Santa Fe Sport' },
      { id: nanoid(), label: 'Santa Fe XL', value: 'Santa Fe XL' },
      { id: nanoid(), label: 'Scoupe', value: 'Scoupe' },
      { id: nanoid(), label: 'Veloster', value: 'Veloster' },
      { id: nanoid(), label: 'Venue', value: 'Venue' },
      { id: nanoid(), label: 'Veracruz', value: 'Veracruz' },
      { id: nanoid(), label: 'cube', value: 'cube' },
    ],
  },
  {
    id: nanoid(),
    label: 'Infiniti',
    value: 'Infiniti',
    model: [
      { id: nanoid(), label: 'EX', value: 'EX' },
      { id: nanoid(), label: 'EX35', value: 'EX35' },
      { id: nanoid(), label: 'EX37', value: 'EX37' },
      { id: nanoid(), label: 'G Convertible', value: 'G Convertible' },
      { id: nanoid(), label: 'G Coupe', value: 'G Coupe' },
      { id: nanoid(), label: 'G Sedan', value: 'G Sedan' },
      { id: nanoid(), label: 'G35 Coupe', value: 'G35 Coupe' },
      { id: nanoid(), label: 'G35 Sport Coupe', value: 'G35 Sport Coupe' },
      { id: nanoid(), label: 'G37 Coupe', value: 'G37 Coupe' },
      { id: nanoid(), label: 'G37 Sedan', value: 'G37 Sedan' },
      { id: nanoid(), label: 'Q60 Convertible', value: 'Q60 Convertible' },
      { id: nanoid(), label: 'Q60 Coupe', value: 'Q60 Coupe' },
    ],
  },
  {
    id: nanoid(),
    label: 'Ineos',
    value: 'Ineos',
    model: [{ id: nanoid(), label: 'Grenadier', value: 'Grenadier' }],
  },
  {
    id: nanoid(),
    label: 'Isuzu',
    value: 'Isuzu',
    model: [
      { id: nanoid(), label: 'Ascender', value: 'Ascender' },
      { id: nanoid(), label: 'Conventional', value: 'Conventional' },
      { id: nanoid(), label: 'Hombre', value: 'Hombre' },
      { id: nanoid(), label: 'Impulse', value: 'Impulse' },
      { id: nanoid(), label: 'Rodeo', value: 'Rodeo' },
      { id: nanoid(), label: 'Rodeo Sport', value: 'Rodeo Sport' },
      { id: nanoid(), label: 'Trooper', value: 'Trooper' },
      { id: nanoid(), label: 'Vehicross', value: 'Vehicross' },
      { id: nanoid(), label: 'i series', value: 'i series' },
    ],
  },
  {
    id: nanoid(),
    label: 'Jaguar',
    value: 'Jaguar',
    model: [
      { id: nanoid(), label: 'E-Pace', value: 'E-Pace' },
      { id: nanoid(), label: 'Coupe', value: 'Coupe' },
      { id: nanoid(), label: 'F-PACE', value: 'F-PACE' },
      { id: nanoid(), label: 'F-TYPE', value: 'F-TYPE' },
      { id: nanoid(), label: 'I-PACE', value: 'I-PACE' },
      { id: nanoid(), label: 'S-Type', value: 'S-Type' },
      { id: nanoid(), label: 'Vanden Plas', value: 'Vanden Plas' },
      { id: nanoid(), label: 'X-Type', value: 'X-Type' },
      { id: nanoid(), label: 'XE', value: 'XE' },
      { id: nanoid(), label: 'XJ Series', value: 'XJ Series' },
      { id: nanoid(), label: 'XK Series', value: 'XK Series' },
    ],
  },
  {
    id: nanoid(),
    label: 'Jeep',
    value: 'Jeep',
    model: [
      { id: nanoid(), label: 'All-New Compass', value: 'All-New Compass' },
      { id: nanoid(), label: 'All-New Wrangler', value: 'All-New Wrangler' },
      {
        id: nanoid(),
        label: 'All-New Wrangler Unlimited',
        value: 'All-New Wrangler Unlimited',
      },
      { id: nanoid(), label: 'Challenger', value: 'Challenger' },
      { id: nanoid(), label: 'Cherokee', value: 'Cherokee' },
      { id: nanoid(), label: 'Comanche', value: 'Comanche' },
      { id: nanoid(), label: 'Commander', value: 'Commander' },
      { id: nanoid(), label: 'Gladiator', value: 'Gladiator' },
      { id: nanoid(), label: 'Grand Cherokee', value: 'Grand Cherokee' },
      { id: nanoid(), label: 'Grand Cherokee L', value: 'Grand Cherokee L' },
      { id: nanoid(), label: 'Grand Cherokee WK', value: 'Grand Cherokee WK' },
      { id: nanoid(), label: 'Grand Wagoneer', value: 'Grand Wagoneer' },
      { id: nanoid(), label: 'Grand Wagoneer L', value: 'Grand Wagoneer L' },
      { id: nanoid(), label: 'Jeep', value: 'Jeep' },
      { id: nanoid(), label: 'Jeep Truck', value: 'Jeep Truck' },
      { id: nanoid(), label: 'Liberty', value: 'Liberty' },
      { id: nanoid(), label: 'Renegade', value: 'Renegade' },
      { id: nanoid(), label: 'Scrambler', value: 'Scrambler' },
      { id: nanoid(), label: 'Thunderbird', value: 'Thunderbird' },
      { id: nanoid(), label: 'Wagoneer', value: 'Wagoneer' },
      { id: nanoid(), label: 'Wagoneer L', value: 'Wagoneer L' },
      { id: nanoid(), label: 'Wrangler', value: 'Wrangler' },
      { id: nanoid(), label: 'Wrangler / TJ', value: 'Wrangler / TJ' },
      { id: nanoid(), label: 'Wrangler / YJ', value: 'Wrangler / YJ' },
      { id: nanoid(), label: 'Wrangler 2-Door', value: 'Wrangler 2-Door' },
      { id: nanoid(), label: 'Wrangler 4-Door', value: 'Wrangler 4-Door' },
      { id: nanoid(), label: 'Wrangler 4xe', value: 'Wrangler 4xe' },
      { id: nanoid(), label: 'Wrangler JK', value: 'Wrangler JK' },
      {
        id: nanoid(),
        label: 'Wrangler JK Unlimited',
        value: 'Wrangler JK Unlimited',
      },
      {
        id: nanoid(),
        label: 'Wrangler Unlimited',
        value: 'Wrangler Unlimited',
      },
    ],
  },
  {
    id: nanoid(),
    label: 'KIA',
    value: 'KIA',
    model: [
      { id: nanoid(), label: 'Ev6', value: 'Ev6' },
      { id: nanoid(), label: 'Ev9', value: 'Ev9' },
      { id: nanoid(), label: 'Borrego', value: 'Borrego' },
      { id: nanoid(), label: 'Cadenza', value: 'Cadenza' },
      { id: nanoid(), label: 'Forte', value: 'Forte' },
      { id: nanoid(), label: 'Forte 5-Door', value: 'Forte 5-Door' },
      { id: nanoid(), label: 'Forte Koup', value: 'Forte Koup' },
      { id: nanoid(), label: 'Forte5', value: 'Forte5' },
      { id: nanoid(), label: 'New Optima', value: 'New Optima' },
      { id: nanoid(), label: 'Sedona', value: 'Sedona' },
      { id: nanoid(), label: 'Seltos', value: 'Seltos' },
      { id: nanoid(), label: 'Sephia', value: 'Sephia' },
      { id: nanoid(), label: 'Sorento', value: 'Sorento' },
      { id: nanoid(), label: 'Soul EV', value: 'Soul EV' },
      { id: nanoid(), label: 'Spectra', value: 'Spectra' },
      { id: nanoid(), label: 'Sportage', value: 'Sportage' },
      { id: nanoid(), label: 'Stinger', value: 'Stinger' },
      { id: nanoid(), label: 'Telluride', value: 'Telluride' },
    ],
  },
  {
    id: nanoid(),
    label: 'Karma',
    value: 'Karma',
    model: [
      { id: nanoid(), label: '6 Series', value: '6 Series' },
      { id: nanoid(), label: 'Revero', value: 'Revero' },
    ],
  },
  {
    id: nanoid(),
    label: 'Lamborghini',
    value: 'Lamborghini',
    model: [
      { id: nanoid(), label: 'Aventador', value: 'Aventador' },
      { id: nanoid(), label: 'Murcielago', value: 'Murcielago' },
      { id: nanoid(), label: 'Revuelto', value: 'Revuelto' },
    ],
  },
  {
    id: nanoid(),
    label: 'Land Rover',
    value: 'Land Rover',
    model: [
      { id: nanoid(), label: 'Convertible', value: 'Convertible' },
      { id: nanoid(), label: 'Defender', value: 'Defender' },
      { id: nanoid(), label: 'Discovery', value: 'Discovery' },
      { id: nanoid(), label: 'Discovery Sport', value: 'Discovery Sport' },
      { id: nanoid(), label: 'Freelander', value: 'Freelander' },
      { id: nanoid(), label: 'New Range Rover', value: 'New Range Rover' },
      { id: nanoid(), label: 'Range Rover', value: 'Range Rover' },
      {
        id: nanoid(),
        label: 'Range Rover Evoque',
        value: 'Range Rover Evoque',
      },
      { id: nanoid(), label: 'Range Rover Sport', value: 'Range Rover Sport' },
      { id: nanoid(), label: 'Range Rover Velar', value: 'Range Rover Velar' },
    ],
  },
  {
    id: nanoid(),
    label: 'Lexus',
    value: 'Lexus',
    model: [
      { id: nanoid(), label: 'ES', value: 'ES' },
      { id: nanoid(), label: 'ES 300h', value: 'ES 300h' },
      { id: nanoid(), label: 'ES 350', value: 'ES 350' },
      { id: nanoid(), label: 'ES Hybrid', value: 'ES Hybrid' },
      { id: nanoid(), label: 'GX', value: 'GX' },
      { id: nanoid(), label: 'NX PHEV', value: 'NX PHEV' },
      { id: nanoid(), label: 'RX PHEV', value: 'RX PHEV' },
      { id: nanoid(), label: 'TX PHEV', value: 'TX PHEV' },
    ],
  },
  {
    id: nanoid(),
    label: 'Lincoln',
    value: 'Lincoln',
    model: [
      { id: nanoid(), label: 'Continental', value: 'Continental' },
      { id: nanoid(), label: 'Zephyr', value: 'Zephyr' },
    ],
  },
  {
    id: nanoid(),
    label: 'Lotus',
    value: 'Lotus',
    model: [
      { id: nanoid(), label: 'Elan', value: 'Elan' },
      { id: nanoid(), label: 'Elise', value: 'Elise' },
      { id: nanoid(), label: 'Emira', value: 'Emira' },
      { id: nanoid(), label: 'Esprit', value: 'Esprit' },
      { id: nanoid(), label: 'Evora', value: 'Evora' },
      { id: nanoid(), label: 'GT', value: 'GT' },
      { id: nanoid(), label: 'Exige', value: 'Exige' },
    ],
  },
  {
    id: nanoid(),
    label: 'MINI',
    value: 'MINI',
    model: [
      { id: nanoid(), label: 'Convertible', value: 'Convertible' },
      { id: nanoid(), label: 'Cooper', value: 'Cooper' },
      { id: nanoid(), label: 'Paceman', value: 'Paceman' },
    ],
  },
  {
    id: nanoid(),
    label: 'Maserati',
    value: 'Maserati',
    model: [
      { id: nanoid(), label: 'Coupe', value: 'Coupe' },
      { id: nanoid(), label: 'Grecale', value: 'Grecale' },
      { id: nanoid(), label: 'Levante', value: 'Levante' },
      { id: nanoid(), label: 'Quattroporte', value: 'Quattroporte' },
      { id: nanoid(), label: 'Spyder', value: 'Spyder' },
    ],
  },
  {
    id: nanoid(),
    label: 'Mazda',
    value: 'Mazda',
    model: [
      { id: nanoid(), label: 'B-Series', value: 'B-Series' },
      { id: nanoid(), label: 'Millenia', value: 'Millenia' },
      { id: nanoid(), label: 'Protege', value: 'Protege' },
      { id: nanoid(), label: 'Protege5', value: 'Protege5' },
      { id: nanoid(), label: 'Tribute', value: 'Tribute' },
    ],
  },
  {
    id: nanoid(),
    label: 'McLaren',
    value: 'McLaren',
    model: [
      { id: nanoid(), label: 'Coupe', value: 'Coupe' },
      { id: nanoid(), label: 'Senna', value: 'Senna' },
      { id: nanoid(), label: 'Senna GTR', value: 'Senna GTR' },
    ],
  },
  {
    id: nanoid(),
    label: 'Mercedes-Benz',
    value: 'Mercedes-Benz',
    model: [
      { id: nanoid(), label: 'E-Class', value: 'E-Class' },
      { id: nanoid(), label: 'EQB', value: 'EQB' },
      { id: nanoid(), label: 'EQE', value: 'EQE' },
      { id: nanoid(), label: 'EQE SUV', value: 'EQE SUV' },
      { id: nanoid(), label: 'EQS', value: 'EQS' },
      { id: nanoid(), label: 'EQS SUV', value: 'EQS SUV' },
      {
        id: nanoid(),
        label: 'AMG GT 4-Door Coupe',
        value: 'AMG GT 4-Door Coupe',
      },
      { id: nanoid(), label: 'AMG GT Coupe', value: 'AMG GT Coupe' },
      { id: nanoid(), label: 'AMG GT Roadster', value: 'AMG GT Roadster' },
      { id: nanoid(), label: 'C-Class Cabriolet', value: 'C-Class Cabriolet' },
      { id: nanoid(), label: 'C-Class Coupe', value: 'C-Class Coupe' },
      { id: nanoid(), label: 'C-Class Sedan', value: 'C-Class Sedan' },
      { id: nanoid(), label: 'CLE', value: 'CLE' },
      { id: nanoid(), label: 'GLC Coupe', value: 'GLC Coupe' },
      { id: nanoid(), label: 'GLE', value: 'GLE' },
      { id: nanoid(), label: 'GLE Coupe', value: 'GLE Coupe' },
      { id: nanoid(), label: 'GLE-Class', value: 'GLE-Class' },
      { id: nanoid(), label: 'GLE-Class Coupe', value: 'GLE-Class Coupe' },
      { id: nanoid(), label: 'Metris Cargo Van', value: 'Metris Cargo Van' },
      {
        id: nanoid(),
        label: 'Metris Passenger Van',
        value: 'Metris Passenger Van',
      },
      { id: nanoid(), label: 'Roadster', value: 'Roadster' },
      { id: nanoid(), label: 'SL Roadster', value: 'SL Roadster' },
      { id: nanoid(), label: 'SLC Roadster', value: 'SLC Roadster' },
      { id: nanoid(), label: 'SLR McLaren', value: 'SLR McLaren' },
      { id: nanoid(), label: 'Sprinter', value: 'Sprinter' },
      {
        id: nanoid(),
        label: 'Sprinter Cab Chassis',
        value: 'Sprinter Cab Chassis',
      },
      {
        id: nanoid(),
        label: 'Sprinter Cargo Van',
        value: 'Sprinter Cargo Van',
      },
      { id: nanoid(), label: 'Sprinter Crew Van', value: 'Sprinter Crew Van' },
      {
        id: nanoid(),
        label: 'Sprinter Passenger Van',
        value: 'Sprinter Passenger Van',
      },
      { id: nanoid(), label: 'Sprinter Van', value: 'Sprinter Van' },
      { id: nanoid(), label: 'Sprinter WORKER', value: 'Sprinter WORKER' },
      {
        id: nanoid(),
        label: 'Sprinter WORKER Cargo Van',
        value: 'Sprinter WORKER Cargo Van',
      },
      { id: nanoid(), label: 'Sprinter Wagon', value: 'Sprinter Wagon' },
    ],
  },
  {
    id: nanoid(),
    label: 'Mercury',
    value: 'Mercury',
    model: [
      { id: nanoid(), label: 'Marauder', value: 'Marauder' },
      { id: nanoid(), label: 'Mariner', value: 'Mariner' },
      { id: nanoid(), label: 'Montego', value: 'Montego' },
      { id: nanoid(), label: 'Monterey', value: 'Monterey' },
      { id: nanoid(), label: 'Mountaineer', value: 'Mountaineer' },
      { id: nanoid(), label: 'Mystique', value: 'Mystique' },
      { id: nanoid(), label: 'Sable', value: 'Sable' },
      { id: nanoid(), label: 'Tracer', value: 'Tracer' },
      { id: nanoid(), label: 'Villager', value: 'Villager' },
      { id: nanoid(), label: 'Villager Van', value: 'Villager Van' },
    ],
  },
  {
    id: nanoid(),
    label: 'Mitsubishi',
    value: 'Mitsubishi',
    model: [
      { id: nanoid(), label: 'Eclipse', value: 'Eclipse' },
      { id: nanoid(), label: 'Eclipse Cross', value: 'Eclipse Cross' },
      { id: nanoid(), label: 'Eclipse Spyder', value: 'Eclipse Spyder' },
      { id: nanoid(), label: 'Endeavor', value: 'Endeavor' },
      { id: nanoid(), label: 'Expo', value: 'Expo' },
      { id: nanoid(), label: 'Challenger', value: 'Challenger' },
      { id: nanoid(), label: 'Diamante', value: 'Diamante' },
      { id: nanoid(), label: 'Lancer Evolution', value: 'Lancer Evolution' },
      {
        id: nanoid(),
        label: 'Lancer Ralliart',
        value: 'TraLancer Ralliartcer',
      },
      { id: nanoid(), label: 'Lancer Sportback', value: 'Lancer Sportback' },
      { id: nanoid(), label: 'Miraage', value: 'Miraage' },
      { id: nanoid(), label: 'Mirage G4', value: 'Mirage G4' },
      { id: nanoid(), label: 'Montero', value: 'Montero' },
      { id: nanoid(), label: 'Montero Sport', value: 'Montero Sport' },
      { id: nanoid(), label: 'Outlander', value: 'Outlander' },
      { id: nanoid(), label: 'Outlander PHEV', value: 'Outlander PHEV' },
      {
        id: nanoid(),
        label: 'Outlander Plug-In Hybrid',
        value: 'Outlander Plug-In Hybrid',
      },
      { id: nanoid(), label: 'Outlander Sport', value: 'Outlander Sport' },
      { id: nanoid(), label: 'Raider', value: 'Raider' },
      { id: nanoid(), label: 'i-MiEV', value: 'i-MiEV' },
    ],
  },
  {
    id: nanoid(),
    label: 'Nissan',
    value: 'Nissan',
    model: [
      { id: nanoid(), label: '350Z Roadster', value: '350Z Roadster' },
      { id: nanoid(), label: '370Z Coupe', value: '370Z Coupe' },
      { id: nanoid(), label: '370Z Roadster', value: '370Z Roadster' },
      { id: nanoid(), label: 'Altima Coupe', value: 'Altima Coupe' },
      { id: nanoid(), label: 'Altima Sedan', value: 'Altima Sedan' },
      { id: nanoid(), label: 'Frontier', value: 'Frontier' },
      { id: nanoid(), label: 'Juke', value: 'Juke' },
      { id: nanoid(), label: 'Leaf', value: 'Leaf' },
      {
        id: nanoid(),
        label: 'Murano CrossCabriolet',
        value: 'Murano CrossCabriolet',
      },
      { id: nanoid(), label: 'NV Passenger', value: 'NV Passenger' },
      { id: nanoid(), label: 'Pathfinder', value: 'Pathfinder' },
      { id: nanoid(), label: 'Pathfinder Hybrid', value: 'Pathfinder Hybrid' },
      { id: nanoid(), label: 'Quest', value: 'Quest' },
      { id: nanoid(), label: 'Rogue', value: 'Rogue' },
      { id: nanoid(), label: 'Rogue Select', value: 'Rogue Select' },
      { id: nanoid(), label: 'Rogue Sport', value: 'Rogue Sport' },
      { id: nanoid(), label: 'Sentra', value: 'Sentra' },
      { id: nanoid(), label: 'Versa', value: 'Versa' },
      { id: nanoid(), label: 'Versa Note', value: 'Versa Note' },
      { id: nanoid(), label: 'Versa Sedan', value: 'Versa Sedan' },
      { id: nanoid(), label: 'Xterra', value: 'Xterra' },
      { id: nanoid(), label: 'cube', value: 'cube' },
    ],
  },
  {
    id: nanoid(),
    label: 'Oldsmobile',
    value: 'Oldsmobile',
    model: [
      { id: nanoid(), label: 'Achieva', value: 'Achieva' },
      { id: nanoid(), label: 'Alero', value: 'Alero' },
      { id: nanoid(), label: 'Ciera', value: 'Ciera' },
      { id: nanoid(), label: 'Custom Cruiser', value: 'Custom Cruiser' },
      { id: nanoid(), label: 'Cutlass Ciera', value: 'Cutlass Ciera' },
      { id: nanoid(), label: 'Cutlass Cruiser', value: 'Cutlass Cruiser' },
      { id: nanoid(), label: 'Cutlass Supreme', value: 'Cutlass Supreme' },
      { id: nanoid(), label: 'Firenza', value: 'Firenza' },
      { id: nanoid(), label: 'Intrigue', value: 'Intrigue' },
      { id: nanoid(), label: 'Regency', value: 'Regency' },
      { id: nanoid(), label: 'Silhouette', value: 'Silhouette' },
    ],
  },
  {
    id: nanoid(),
    label: 'Plymouth',
    value: 'Plymouth',
    model: [
      { id: nanoid(), label: 'Breeze', value: 'Breeze' },
      { id: nanoid(), label: 'Caravelle', value: 'Caravelle' },
      { id: nanoid(), label: 'Conquest', value: 'Conquest' },
      { id: nanoid(), label: 'Grand Voyager', value: 'Grand Voyager' },
      { id: nanoid(), label: 'Laser', value: 'Laser' },
      { id: nanoid(), label: 'Neon', value: 'Neon' },
      { id: nanoid(), label: 'Prowler', value: 'Prowler' },
      { id: nanoid(), label: 'Sundance', value: 'Sundance' },
      { id: nanoid(), label: 'Voyager', value: 'Voyager' },
    ],
  },
  {
    id: nanoid(),
    label: 'Polestar',
    value: 'Polestar',
    model: [{ id: nanoid(), label: '2', value: '2' }],
  },
  {
    id: nanoid(),
    label: 'Pontiac',
    value: 'Pontiac',
    model: [
      { id: nanoid(), label: 'Aztek', value: 'Aztek' },
      { id: nanoid(), label: 'Bonneville', value: 'Bonneville' },
      { id: nanoid(), label: 'Fiero', value: 'Fiero' },
      { id: nanoid(), label: 'Firebird', value: 'Firebird' },
      { id: nanoid(), label: 'Parisienne', value: 'Parisienne' },
      { id: nanoid(), label: 'Solstice', value: 'Solstice' },
      { id: nanoid(), label: 'Sunfire', value: 'Sunfire' },
      { id: nanoid(), label: 'Torrent', value: 'Torrent' },
      { id: nanoid(), label: 'Vibe', value: 'Vibe' },
    ],
  },
  {
    id: nanoid(),
    label: 'Porsche',
    value: 'Porsche',
    model: [
      { id: nanoid(), label: 'Boxster', value: 'Boxster' },
      { id: nanoid(), label: 'Carrera GT', value: 'Carrera GT' },
      { id: nanoid(), label: 'Cayenne', value: 'Cayenne' },
      { id: nanoid(), label: 'Cayenne Coup', value: 'Cayenne Coup' },
      { id: nanoid(), label: 'Coupe', value: 'Coupe' },
      { id: nanoid(), label: 'Panamera', value: 'Panamera' },
    ],
  },
  {
    id: nanoid(),
    label: 'RAM',
    value: 'RAM',
    model: [
      {
        id: nanoid(),
        label: 'ProMaster Cab Chassis',
        value: 'ProMaster Cab Chassis',
      },
      {
        id: nanoid(),
        label: 'ProMaster Cargo Van',
        value: 'ProMaster Cargo Van',
      },
      { id: nanoid(), label: 'ProMaster Cutaway', value: 'ProMaster Cutaway' },
      {
        id: nanoid(),
        label: 'ProMaster Window Van',
        value: 'ProMaster Window Van',
      },
      { id: nanoid(), label: 'Promaster 1500', value: 'Promaster 1500' },
      { id: nanoid(), label: 'Promaster 2500', value: 'Promaster 2500' },
      { id: nanoid(), label: 'Promaster 3500', value: 'Promaster 3500' },
      { id: nanoid(), label: 'Promaster City', value: 'Promaster City' },
      { id: nanoid(), label: 'Silverado 3500', value: 'Silverado 3500' },
    ],
  },
  {
    id: nanoid(),
    label: 'Rolls-Royce',
    value: 'Rolls-Royce',
    model: [
      { id: nanoid(), label: 'Carmaque', value: 'Carmaque' },
      { id: nanoid(), label: 'Corniche', value: 'Corniche' },
      { id: nanoid(), label: 'Silver Dawn', value: 'Silver Dawn' },
      { id: nanoid(), label: 'Silver Seraph', value: 'Silver Seraph' },
      { id: nanoid(), label: 'Silver Spirit', value: 'Silver Spirit' },
      { id: nanoid(), label: 'Silver Spur', value: 'Silver Spur' },
      { id: nanoid(), label: 'Spectre', value: 'Spectre' },
    ],
  },
  {
    id: nanoid(),
    label: 'Saab',
    value: 'Saab',
    model: [{ id: nanoid(), label: 'Convertible', value: 'Convertible' }],
  },
  {
    id: nanoid(),
    label: 'Saturn',
    value: 'Saturn',
    model: [
      { id: nanoid(), label: 'L-Series', value: 'L-Series' },
      { id: nanoid(), label: 'Relay', value: 'Relay' },
      { id: nanoid(), label: 'S-Series', value: 'S-Series' },
      { id: nanoid(), label: 'VUE', value: 'VUE' },
    ],
  },
  {
    id: nanoid(),
    label: 'Sterling',
    value: 'Sterling',
    model: [
      { id: nanoid(), label: 'Acterra', value: 'Acterra' },
      { id: nanoid(), label: 'Bullet', value: 'Bullet' },
      {
        id: nanoid(),
        label: 'Mitsubishi Chassis COE',
        value: 'Mitsubishi Chassis COE',
      },
    ],
  },
  {
    id: nanoid(),
    label: 'Subaru',
    value: 'Subaru',
    model: [
      { id: nanoid(), label: 'Ascent', value: 'Ascent' },
      { id: nanoid(), label: 'B9 Tribeca', value: 'B9 Tribeca' },
      { id: nanoid(), label: 'Crosstrek', value: 'Crosstrek' },
      { id: nanoid(), label: 'Forester', value: 'Forester' },
      { id: nanoid(), label: 'Impreza', value: 'Impreza' },
      { id: nanoid(), label: 'Legacy', value: 'Legacy' },
      { id: nanoid(), label: 'Loyale', value: 'Loyale' },
      { id: nanoid(), label: 'Solterra', value: 'Solterra' },
      { id: nanoid(), label: 'Tribeca', value: 'Tribeca' },
      { id: nanoid(), label: 'XV Crosstrek', value: 'XV Crosstrek' },
    ],
  },
  {
    id: nanoid(),
    label: 'Suzuki',
    value: 'Suzuki',
    model: [
      { id: nanoid(), label: 'Edge', value: 'Edge' },
      { id: nanoid(), label: 'Equator', value: 'Equator' },
      { id: nanoid(), label: 'Esteem', value: 'Esteem' },
      { id: nanoid(), label: 'Aerio', value: 'Aerio' },
      { id: nanoid(), label: 'Forenza', value: 'Forenza' },
      { id: nanoid(), label: 'Forenza Wagon', value: 'Forenza Wagon' },
      { id: nanoid(), label: 'Reno', value: 'Reno' },
      { id: nanoid(), label: 'SX4 Crossover', value: 'SX4 Crossover' },
      { id: nanoid(), label: 'SX4 Sedan', value: 'SX4 Sedan' },
      { id: nanoid(), label: 'Sidekick', value: 'Sidekick' },
      { id: nanoid(), label: 'Verona', value: 'Verona' },
    ],
  },
  {
    id: nanoid(),
    label: 'Tesla',
    value: 'Tesla',
    model: [
      { id: nanoid(), label: '3', value: '3' },
      { id: nanoid(), label: 'Cybertruck', value: 'Cybertruck' },
      { id: nanoid(), label: 'Model 3', value: 'Model 3' },
      { id: nanoid(), label: 'Model S', value: 'Model S' },
      { id: nanoid(), label: 'Model X', value: 'Model X' },
      { id: nanoid(), label: 'Model Y', value: 'Model Y' },
      { id: nanoid(), label: 'Roadster', value: 'Roadster' },
    ],
  },
  {
    id: nanoid(),
    label: 'Toyota',
    value: 'Toyota',
    model: [
      { id: nanoid(), label: 'Echo', value: 'Echo' },
      { id: nanoid(), label: '4Runner', value: '4Runner' },
      { id: nanoid(), label: 'Camry', value: 'Camry' },
      { id: nanoid(), label: 'Celica', value: 'Celica' },
      { id: nanoid(), label: 'Corolla', value: 'Corolla' },
      { id: nanoid(), label: 'Corolla Sedan', value: 'Corolla Sedan' },
      { id: nanoid(), label: 'Cressida', value: 'Cressida' },
      { id: nanoid(), label: 'FJ Cruiser', value: 'FJ Cruiser' },
      { id: nanoid(), label: 'Grand Highlander', value: 'Grand Highlander' },
      {
        id: nanoid(),
        label: 'Grand Highlander Hybrid',
        value: 'Grand Highlander Hybrid',
      },
      { id: nanoid(), label: 'Highlander', value: 'Highlander' },
      { id: nanoid(), label: 'Highlander Hybrid', value: 'Highlander Hybrid' },
      { id: nanoid(), label: 'Land Cruiser', value: 'Land Cruiser' },
      { id: nanoid(), label: 'MR2 Spyder', value: 'MR2 Spyder' },
      { id: nanoid(), label: 'Paseo', value: 'Paseo' },
      {
        id: nanoid(),
        label: 'Pickup Commercial / Camper',
        value: 'Pickup Commercial / Camper',
      },
      { id: nanoid(), label: 'Previa', value: 'Previa' },
      { id: nanoid(), label: 'Prius Prime', value: 'Prius Prime' },
      { id: nanoid(), label: 'RAV4', value: 'RAV4' },
      { id: nanoid(), label: 'Sequoia', value: 'Sequoia' },
      { id: nanoid(), label: 'Sienna', value: 'Sienna' },
      { id: nanoid(), label: 'Tercel', value: 'Tercel' },
      { id: nanoid(), label: 'Tundra', value: 'Tundra' },
      { id: nanoid(), label: 'Venza', value: 'Venza' },
      { id: nanoid(), label: 'Yaris Sedan', value: 'Yaris Sedan' },
    ],
  },
  {
    id: nanoid(),
    label: 'Volkswagen',
    value: 'Volkswagen',
    model: [
      { id: nanoid(), label: 'e-Golf', value: 'e-Golf' },
      { id: nanoid(), label: 'Eos', value: 'Eos' },
      { id: nanoid(), label: 'Eurovan', value: 'Eurovan' },
      { id: nanoid(), label: 'Arteon', value: 'Arteon' },
      { id: nanoid(), label: 'Beetle', value: 'Beetle' },
      {
        id: nanoid(),
        label: 'Beetle Convertible',
        value: 'Beetle Convertible',
      },
      { id: nanoid(), label: 'Cabriolet', value: 'Cabriolet' },
      { id: nanoid(), label: 'Golf SportWagen', value: 'Golf SportWagen' },
      { id: nanoid(), label: 'Jetta', value: 'Jetta' },
      { id: nanoid(), label: 'Jetta SportWagen', value: 'Jetta SportWagen' },
      { id: nanoid(), label: 'New Beetle', value: 'New Beetle' },
      { id: nanoid(), label: 'New GTI', value: 'New GTI' },
      { id: nanoid(), label: 'New Jetta', value: 'New Jetta' },
      { id: nanoid(), label: 'Phaeton', value: 'Phaeton' },
      { id: nanoid(), label: 'Tiguan Limited', value: 'Tiguan Limited' },
      { id: nanoid(), label: 'Touareg', value: 'Touareg' },
      { id: nanoid(), label: 'Touareg 2', value: 'Touareg 2' },
    ],
  },
  {
    id: nanoid(),
    label: 'Volvo',
    value: 'Volvo',
    model: [
      { id: nanoid(), label: 'Conventional', value: 'Conventional' },
      { id: nanoid(), label: 'FE6', value: 'FE6' },
      { id: nanoid(), label: 'New S40', value: 'New S40' },
      { id: nanoid(), label: 'XC90', value: 'XC90' },
    ],
  },
];

export const motorcycleModelMakes = [
  {
    id: nanoid(),
    label: 'Ajp',
    value: 'Ajp',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Aprilia',
    value: 'Aprilia',
    model: [
      { id: nanoid(), label: 'Scarabeo', value: 'Scarabeo' },
      { id: nanoid(), label: 'Shiver', value: 'Shiver' },
      { id: nanoid(), label: 'Tuareg', value: 'Tuareg' },
    ],
  },
  {
    id: nanoid(),
    label: 'Argo',
    value: 'Argo',
    model: [{ id: nanoid(), label: 'Xplorer', value: 'Xplorer' }],
  },
  {
    id: nanoid(),
    label: 'Benelli',
    value: 'Benelli',
    model: [
      { id: nanoid(), label: 'Imperiale', value: 'Imperiale' },
      { id: nanoid(), label: 'Leoncino', value: 'Leoncino' },
      { id: nanoid(), label: 'Leoncino Trail', value: 'Leoncino Trail' },
    ],
  },
  {
    id: nanoid(),
    label: 'Beta',
    value: 'Beta',
    model: [
      { id: nanoid(), label: 'Evo', value: 'Evo' },
      { id: nanoid(), label: 'Evo Factory', value: 'Evo Factory' },
      { id: nanoid(), label: 'Evo Sport', value: 'Evo Sport' },
      { id: nanoid(), label: 'Rr Race Edition', value: 'Rr Race Edition' },
      { id: nanoid(), label: 'Xtrainer', value: 'EXtrainer' },
    ],
  },
  {
    id: nanoid(),
    label: 'Bimota',
    value: 'Bimota',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Bintelli',
    value: 'Bintelli',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Bmw',
    value: 'Bmw',
    model: [
      { id: nanoid(), label: 'R Ninet', value: 'R Ninet' },
      { id: nanoid(), label: 'Side Car', value: 'Side Car' },
    ],
  },
  {
    id: nanoid(),
    label: 'Buell',
    value: 'Buell',
    model: [
      { id: nanoid(), label: 'Cyclone', value: 'Cyclone' },
      { id: nanoid(), label: 'Hammerhead', value: 'Hammerhead' },
      { id: nanoid(), label: 'Ulysses', value: 'Ulysses' },
    ],
  },
  {
    id: nanoid(),
    label: 'Can-Am',
    value: 'Can-Am',
    model: [
      { id: nanoid(), label: 'Commander', value: 'Commander' },
      { id: nanoid(), label: 'Commander Max', value: 'Commander Max' },
      { id: nanoid(), label: 'Defender', value: 'Defender' },
      { id: nanoid(), label: 'Outlander', value: 'Outlander' },
      { id: nanoid(), label: 'Renegade', value: 'Renegade' },
      { id: nanoid(), label: 'Ryker Sport', value: 'Ryker Sport' },
      { id: nanoid(), label: 'Spyder', value: 'Spyder' },
      { id: nanoid(), label: 'Spyder F3', value: 'Spyder F3' },
      { id: nanoid(), label: 'Spyder Gs', value: 'Spyder Gs' },
      { id: nanoid(), label: 'Spyder Rt', value: 'Spyder Rt' },
      { id: nanoid(), label: 'Spyder St', value: 'Spyder St' },
    ],
  },
  {
    id: nanoid(),
    label: 'Cfmoto',
    value: 'Cfmoto',
    model: [
      { id: nanoid(), label: 'Cforce', value: 'Cforce' },
      { id: nanoid(), label: 'Ibex', value: 'Ibex' },
      { id: nanoid(), label: 'Zforce', value: 'Zforce' },
    ],
  },
  {
    id: nanoid(),
    label: 'Coolster',
    value: 'Coolster',
    model: [{ id: nanoid(), label: 'Coolster', value: 'Coolster' }],
  },
  {
    id: nanoid(),
    label: 'Custom',
    value: 'Custom',
    model: [
      { id: nanoid(), label: 'Electra Glide', value: 'Electra Glide' },
      { id: nanoid(), label: 'Bobber', value: 'Bobber' },
      { id: nanoid(), label: 'Chopper', value: 'Chopper' },
      {
        id: nanoid(),
        label: 'Motorcycle Trailer',
        value: 'Motorcycle Trailer',
      },
      { id: nanoid(), label: 'Trike', value: 'Trike' },
    ],
  },
  {
    id: nanoid(),
    label: 'Ducati',
    value: 'Ducati',
    model: [
      { id: nanoid(), label: 'Desert Sled', value: 'Desert Sled' },
      { id: nanoid(), label: 'Desertx', value: 'Desertx' },
      { id: nanoid(), label: 'Desmo', value: 'Desmo' },
      { id: nanoid(), label: 'Diavel', value: 'Diavel' },
      { id: nanoid(), label: 'Full Throttle', value: 'Full Throttle' },
      { id: nanoid(), label: 'Hypermotard', value: 'Hypermotard' },
      { id: nanoid(), label: 'Hyperstrada', value: 'Hyperstrada' },
      { id: nanoid(), label: 'Monster', value: 'Monster' },
      { id: nanoid(), label: 'Panigale', value: 'Panigale' },
      { id: nanoid(), label: 'Scrambler', value: 'Scrambler' },
      { id: nanoid(), label: 'Streetfighter', value: 'Streetfighter' },
      { id: nanoid(), label: 'Superbike', value: 'Superbike' },
      { id: nanoid(), label: 'Superleggera', value: 'Superleggera' },
      { id: nanoid(), label: 'Superleggera V4', value: 'Superleggera V4' },
      { id: nanoid(), label: 'Supersport', value: 'Supersport' },
      { id: nanoid(), label: 'Xdiavel', value: 'Xdiavel' },
    ],
  },
  {
    id: nanoid(),
    label: 'Energica',
    value: 'Energica',
    model: [
      { id: nanoid(), label: 'Ego', value: 'Ego' },
      { id: nanoid(), label: 'Eva', value: 'Eva' },
    ],
  },
  {
    id: nanoid(),
    label: 'Gem',
    value: 'Gem',
    model: [{ id: nanoid(), label: 'E4', value: 'E4' }],
  },
  {
    id: nanoid(),
    label: 'Gpx',
    value: 'Gpx',
    model: [
      { id: nanoid(), label: 'Fse', value: 'Fse' },
      { id: nanoid(), label: 'Tse', value: 'Tse' },
    ],
  },
  {
    id: nanoid(),
    label: 'Harley-Davidson',
    value: 'Harley-Davidson',
    model: [
      { id: nanoid(), label: 'Electra Glide', value: 'Electra Glide' },
      { id: nanoid(), label: 'Blackline', value: 'Blackline' },
      { id: nanoid(), label: 'Breakout', value: 'Breakout' },
      { id: nanoid(), label: 'Dyna Wide Glide', value: 'Dyna Wide Glide' },
      { id: nanoid(), label: 'Flde', value: 'Flde' },
      { id: nanoid(), label: 'Flhtkse', value: 'Flhtkse' },
      { id: nanoid(), label: 'Fltruse', value: 'Fltruse' },
      { id: nanoid(), label: 'Fltrxse', value: 'Fltrxse' },
      { id: nanoid(), label: 'Forty Eight', value: 'Forty Eight' },
      { id: nanoid(), label: 'Freewheeler', value: 'Freewheeler' },
      { id: nanoid(), label: 'Freewheeler Year', value: 'Freewheeler Year' },
      { id: nanoid(), label: 'Heritage Softail', value: 'Heritage Softail' },
      { id: nanoid(), label: 'Heritage Springer', value: 'Heritage Springer' },
      { id: nanoid(), label: 'Knucklehead', value: 'Knucklehead' },
      { id: nanoid(), label: 'Livewire', value: 'Livewire' },
      { id: nanoid(), label: 'Low Rider', value: 'Low Rider' },
      { id: nanoid(), label: 'Nightster', value: 'Nightster' },
      { id: nanoid(), label: 'Pan America', value: 'Pan America' },
      { id: nanoid(), label: 'Panhead', value: 'Panhead' },
      { id: nanoid(), label: 'Road Glide', value: 'Road Glide' },
      { id: nanoid(), label: 'Roadster', value: 'Roadster' },
      { id: nanoid(), label: 'S Series', value: 'S Series' },
      { id: nanoid(), label: 'Seventy Two', value: 'Seventy Two' },
      { id: nanoid(), label: 'Shovelhead', value: 'Shovelhead' },
      { id: nanoid(), label: 'Side Car', value: 'Side Car' },
      { id: nanoid(), label: 'Sport Glide', value: 'Sport Glide' },
      { id: nanoid(), label: 'Sportster', value: 'Sportster' },
      { id: nanoid(), label: 'Sportster 1200', value: 'Sportster 1200' },
      { id: nanoid(), label: 'Sportster 883', value: 'Sportster 883' },
      {
        id: nanoid(),
        label: 'Sportster Iron 1200',
        value: 'Sportster Iron 1200',
      },
      { id: nanoid(), label: 'Sportster S', value: 'Sportster S' },
      { id: nanoid(), label: 'Sportster Xr1200', value: 'Sportster Xr1200' },
      { id: nanoid(), label: 'Springer', value: 'Springer' },
      { id: nanoid(), label: 'Street', value: 'Street' },
      { id: nanoid(), label: 'Street Bob', value: 'Street Bob' },
      { id: nanoid(), label: 'Street Glide', value: 'Street Glide' },
      { id: nanoid(), label: 'Street Rod', value: 'Street Rod' },
      { id: nanoid(), label: 'Super Glide', value: 'Super Glide' },
      { id: nanoid(), label: 'Tour Glide', value: 'Tour Glide' },
      { id: nanoid(), label: 'Tri Glide', value: 'Tri Glide' },
      { id: nanoid(), label: 'Vrscse2', value: 'Vrscse2' },
    ],
  },
  {
    id: nanoid(),
    label: 'Hisun',
    value: 'Hisun',
    model: [{ id: nanoid(), label: 'Sector', value: 'Sector' }],
  },
  {
    id: nanoid(),
    label: 'Honda',
    value: 'Honda',
    model: [
      { id: nanoid(), label: 'Elite', value: 'Elite' },
      { id: nanoid(), label: 'Express', value: 'Express' },
      { id: nanoid(), label: 'CB1000R', value: 'CB1000R' },
      { id: nanoid(), label: 'Dream', value: 'Dream' },
      { id: nanoid(), label: 'Elsinore', value: 'Elsinore' },
      { id: nanoid(), label: 'Fourtrax Foreman', value: 'Fourtrax Foreman' },
      { id: nanoid(), label: 'Gl500 Silver Wing', value: 'Gl500 Silver Wing' },
      {
        id: nanoid(),
        label: 'Gold Wing Valkyrie',
        value: 'Gold Wing Valkyrie',
      },
      { id: nanoid(), label: 'Interceptor', value: 'Interceptor' },
      { id: nanoid(), label: 'Interstate', value: 'Interstate' },
      { id: nanoid(), label: 'Metropolitan', value: 'Metropolitan' },
      { id: nanoid(), label: 'Monkey', value: 'Monkey' },
      { id: nanoid(), label: 'Montesa', value: 'Montesa' },
      { id: nanoid(), label: 'Montesa Cota', value: 'Montesa Cota' },
      { id: nanoid(), label: 'Pioneer 1000', value: 'Pioneer 1000' },
      { id: nanoid(), label: 'Pioneer 1000 5', value: 'Pioneer 1000 5' },
      {
        id: nanoid(),
        label: 'Pioneer 1000 6 Crew',
        value: 'Pioneer 1000 6 Crew',
      },
      { id: nanoid(), label: 'Pioneer 500', value: 'Pioneer 500' },
      { id: nanoid(), label: 'Pioneer 520', value: 'Pioneer 520' },
      { id: nanoid(), label: 'Pioneer 700 4', value: 'Pioneer 700 4' },
      { id: nanoid(), label: 'Rancher', value: 'Rancher' },
      { id: nanoid(), label: 'Rebel', value: 'Rebel' },
      { id: nanoid(), label: 'Rebel 1100', value: 'Rebel 1100' },
      { id: nanoid(), label: 'Rebel 300', value: 'Rebel 300' },
      { id: nanoid(), label: 'Rebel 500', value: 'Rebel 500' },
      { id: nanoid(), label: 'Reflex', value: 'Reflex' },
      { id: nanoid(), label: 'Sabre', value: 'Sabre' },
      { id: nanoid(), label: 'Scrambler', value: 'Scrambler' },
      { id: nanoid(), label: 'Silver Wing', value: 'Silver Wing' },
      { id: nanoid(), label: 'Spree', value: 'Spree' },
      { id: nanoid(), label: 'Stateline', value: 'Stateline' },
      { id: nanoid(), label: 'Super Cub', value: 'Super Cub' },
      { id: nanoid(), label: 'Super Cub C125', value: 'Super Cub C125' },
      { id: nanoid(), label: 'Super Hawk', value: 'Super Hawk' },
      { id: nanoid(), label: 'Valkyrie', value: 'Valkyrie' },
      { id: nanoid(), label: 'Vtx 1800 Tourer', value: 'Vtx 1800 Tourer' },
    ],
  },
  {
    id: nanoid(),
    label: 'Husqvarna',
    value: 'Husqvarna',
    model: [
      { id: nanoid(), label: 'Enduro', value: 'Enduro' },
      { id: nanoid(), label: 'Extreme Cross', value: 'Extreme Cross' },
      { id: nanoid(), label: '12edrive', value: '12edrive' },
      { id: nanoid(), label: '16edrive', value: '16edrive' },
      { id: nanoid(), label: 'Fe', value: 'Fe' },
      { id: nanoid(), label: 'Norden', value: 'Norden' },
      { id: nanoid(), label: 'Supermoto', value: 'Supermoto' },
      { id: nanoid(), label: 'Svartpilen', value: 'Svartpilen' },
      { id: nanoid(), label: 'Te', value: 'Te' },
      { id: nanoid(), label: 'Vitpilen', value: 'Vitpilen' },
    ],
  },
  {
    id: nanoid(),
    label: 'Indian',
    value: 'Indian',
    model: [
      { id: nanoid(), label: 'Challenger', value: 'Challenger' },
      { id: nanoid(), label: 'Chief', value: 'Chief' },
      { id: nanoid(), label: 'Chief Bobber', value: 'Chief Bobber' },
      { id: nanoid(), label: 'Chieftain', value: 'Chieftain' },
      {
        id: nanoid(),
        label: 'Ftr Championship Edition',
        value: 'Ftr Championship Edition',
      },
      { id: nanoid(), label: 'Roadmaster', value: 'Roadmaster' },
      { id: nanoid(), label: 'Springfield', value: 'Springfield' },
      { id: nanoid(), label: 'Super Chief', value: 'Super Chief' },
      { id: nanoid(), label: 'Vintage', value: 'Vintage' },
    ],
  },
  {
    id: nanoid(),
    label: 'Intense',
    value: 'Intense',
    model: [{ id: nanoid(), label: 'Tazer Mx', value: 'Tazer Mx' }],
  },
  {
    id: nanoid(),
    label: 'Kawasaki',
    value: 'Kawasaki',
    model: [
      { id: nanoid(), label: 'Elektrode', value: 'Elektrode' },
      { id: nanoid(), label: 'Eliminator', value: 'Eliminator' },
      { id: nanoid(), label: 'Er 6n', value: 'Er 6n' },
      { id: nanoid(), label: 'Ke', value: 'Ke' },
      { id: nanoid(), label: 'Mule', value: 'Mule' },
      { id: nanoid(), label: 'Teryx', value: 'Teryx' },
      { id: nanoid(), label: 'Versys', value: 'Versys' },
      { id: nanoid(), label: 'Versys 1000', value: 'Versys 1000' },
      { id: nanoid(), label: 'Versys 650', value: 'Versys 650' },
      { id: nanoid(), label: 'Versys X', value: 'Versys X' },
      { id: nanoid(), label: 'Voyager', value: 'Voyager' },
      {
        id: nanoid(),
        label: 'Vulcan 1700 Vaquero',
        value: 'Vulcan 1700 Vaquero',
      },
      {
        id: nanoid(),
        label: 'Vulcan 1700 Voyager',
        value: 'Vulcan 1700 Voyager',
      },
    ],
  },
  {
    id: nanoid(),
    label: 'Ktm',
    value: 'Ktm',
    model: [
      { id: nanoid(), label: 'Exc', value: 'Exc' },
      { id: nanoid(), label: 'Exc F', value: 'Exc F' },
      { id: nanoid(), label: 'Exc G', value: 'Exc G' },
      { id: nanoid(), label: '12edrive', value: '12edrive' },
      { id: nanoid(), label: '16edrive', value: '16edrive' },
      { id: nanoid(), label: '690 Enduro', value: '690 Enduro' },
      { id: nanoid(), label: '990 Adventure', value: '990 Adventure' },
      { id: nanoid(), label: '990 Supermoto', value: '990 Supermoto' },
      { id: nanoid(), label: 'Adventure', value: 'Adventure' },
      { id: nanoid(), label: 'Duke', value: 'Duke' },
      { id: nanoid(), label: 'Freeride', value: 'Freeride' },
      { id: nanoid(), label: 'Super Adventure', value: 'Super Adventure' },
      { id: nanoid(), label: 'Super Duke', value: 'Super Duke' },
      { id: nanoid(), label: 'Super Moto', value: 'Super Moto' },
      { id: nanoid(), label: 'Sx E', value: 'Sx E' },
    ],
  },
  {
    id: nanoid(),
    label: 'Kymco',
    value: 'Kymco',
    model: [
      { id: nanoid(), label: 'K Pipe', value: 'K Pipe' },
      { id: nanoid(), label: 'Like', value: 'Like' },
      { id: nanoid(), label: 'Mongoose', value: 'Mongoose' },
      { id: nanoid(), label: 'People', value: 'People' },
      { id: nanoid(), label: 'Spade', value: 'Spade' },
      { id: nanoid(), label: 'Super 8', value: 'Super 8' },
    ],
  },
  {
    id: nanoid(),
    label: 'Lance',
    value: 'Lance',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Livewire',
    value: 'Livewire',
    model: [{ id: nanoid(), label: 'One', value: 'One' }],
  },
  {
    id: nanoid(),
    label: 'Niu',
    value: 'Niu',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Onyx',
    value: 'Onyx',
    model: [{ id: nanoid(), label: 'Ranger', value: 'Ranger' }],
  },
  {
    id: nanoid(),
    label: 'Oset',
    value: 'Oset',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Piaggio',
    value: 'Piaggio',
    model: [
      { id: nanoid(), label: 'Liberty', value: 'Liberty' },
      { id: nanoid(), label: 'Piaggio 1 Active', value: 'Piaggio 1 Active' },
      { id: nanoid(), label: 'Vespa', value: 'Vespa' },
    ],
  },
  {
    id: nanoid(),
    label: 'Polaris',
    value: 'Polaris',
    model: [
      { id: nanoid(), label: 'General Xp 4 1000', value: 'General Xp 4 1000' },
      { id: nanoid(), label: 'Ranger', value: 'Ranger' },
      { id: nanoid(), label: 'Ranger 150', value: 'Ranger 150' },
      { id: nanoid(), label: 'Ranger Crew 1000', value: 'Ranger Crew 1000' },
      {
        id: nanoid(),
        label: 'Ranger Crew Xp 1000',
        value: 'Ranger Crew Xp 1000',
      },
    ],
  },
  {
    id: nanoid(),
    label: 'Qjmotor',
    value: 'Qjmotor',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Quietkat',
    value: 'Quietkat',
    model: [{ id: nanoid(), label: 'Ranger', value: 'Ranger' }],
  },
  {
    id: nanoid(),
    label: 'Rewaco',
    value: 'Rewaco',
    model: [
      { id: nanoid(), label: 'Nightster', value: 'Nightster' },
      { id: nanoid(), label: 'Sportster', value: 'Sportster' },
    ],
  },
  {
    id: nanoid(),
    label: 'Royal Enfield',
    value: 'Royal Enfield',
    model: [
      { id: nanoid(), label: 'Bullet', value: 'Bullet' },
      { id: nanoid(), label: 'Bullet Trials 500', value: 'Bullet Trials 500' },
      { id: nanoid(), label: 'Continental', value: 'Continental' },
      { id: nanoid(), label: 'Continental Gt', value: 'Continental Gt' },
      { id: nanoid(), label: 'Interceptor', value: 'Interceptor' },
      { id: nanoid(), label: 'Meteor', value: 'Meteor' },
    ],
  },
  {
    id: nanoid(),
    label: 'Segway',
    value: 'Segway',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Sherco',
    value: 'Sherco',
    model: [
      { id: nanoid(), label: '250 Se R', value: '250 Se R' },
      { id: nanoid(), label: '250 Sef R', value: '250 Sef R' },
      { id: nanoid(), label: '300 Se R', value: '300 Se R' },
      { id: nanoid(), label: '300 Sef R', value: '300 Sef R' },
      { id: nanoid(), label: '450 Sef R', value: '450 Sef R' },
    ],
  },
  {
    id: nanoid(),
    label: 'Ski-Doo',
    value: 'Ski-Doo',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Slingshot',
    value: 'Slingshot',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Sondors',
    value: 'Sondors',
    model: [{ id: nanoid(), label: 'Metacycle', value: 'Metacycle' }],
  },
  {
    id: nanoid(),
    label: 'Specialized',
    value: 'Specialized',
    model: [
      { id: nanoid(), label: 'Turbo Creo', value: 'Turbo Creo' },
      { id: nanoid(), label: 'Turbo Kenevo', value: 'Turbo Kenevo' },
      { id: nanoid(), label: 'Turbo Levo', value: 'Turbo Levo' },
      { id: nanoid(), label: 'Turbo Levo Sl', value: 'Turbo Levo Sl' },
      { id: nanoid(), label: 'Turbo Tero', value: 'Turbo Tero' },
    ],
  },
  {
    id: nanoid(),
    label: 'Stacyc',
    value: 'Stacyc',
    model: [
      { id: nanoid(), label: '12 Edrive', value: '12 Edrive' },
      { id: nanoid(), label: '16 Edrive', value: '16 Edrive' },
      { id: nanoid(), label: '18 Edrive', value: '18 Edrive' },
      { id: nanoid(), label: '20 Edrive', value: '20 Edrive' },
      { id: nanoid(), label: 'Husqvarna Replica', value: 'Husqvarna Replica' },
    ],
  },
  {
    id: nanoid(),
    label: 'Stark',
    value: 'Stark',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Sunday',
    value: 'Sunday',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Super73',
    value: 'Super73',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Suzuki',
    value: 'Suzuki',
    model: [
      { id: nanoid(), label: 'Eiger', value: 'Eiger' },
      { id: nanoid(), label: 'Boulevard', value: 'Boulevard' },
      { id: nanoid(), label: 'Intruder', value: 'Intruder' },
    ],
  },
  {
    id: nanoid(),
    label: 'Swm',
    value: 'Swm',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Sym',
    value: 'Sym',
    model: [
      { id: nanoid(), label: 'Fiddle', value: 'Fiddle' },
      { id: nanoid(), label: 'Fiddle 4', value: 'Fiddle 4' },
      { id: nanoid(), label: 'Jet 14', value: 'Jet 14' },
    ],
  },
  {
    id: nanoid(),
    label: 'Thumpstar',
    value: 'Thumpstar',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Timbersled',
    value: 'Timbersled',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Torrot',
    value: 'Torrot',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Trailmaster',
    value: 'Trailmaster',
    model: [{ id: nanoid(), label: 'Mini Bike', value: 'Mini Bike' }],
  },
  {
    id: nanoid(),
    label: 'Triumph',
    value: 'Triumph',
    model: [
      { id: nanoid(), label: 'America', value: 'America' },
      { id: nanoid(), label: 'Bonneville', value: 'Bonneville' },
      { id: nanoid(), label: 'Bonneville Bobber', value: 'Bonneville Bobber' },
      {
        id: nanoid(),
        label: 'Bonneville Speedmaster',
        value: 'Bonneville Speedmaster',
      },
      { id: nanoid(), label: 'Bonneville T100', value: 'Bonneville T100' },
      { id: nanoid(), label: 'Bonneville T120', value: 'Bonneville T120' },
      { id: nanoid(), label: 'Legend', value: 'Legend' },
      { id: nanoid(), label: 'Rocket 3', value: 'Rocket 3' },
      { id: nanoid(), label: 'Rocket Iii', value: 'Rocket Iii' },
      { id: nanoid(), label: 'Scrambler', value: 'Scrambler' },
      { id: nanoid(), label: 'Scrambler 1200', value: 'Scrambler 1200' },
      { id: nanoid(), label: 'Scrambler 900', value: 'Scrambler 900' },
      { id: nanoid(), label: 'Speed', value: 'Speed' },
      { id: nanoid(), label: 'Speed Triple', value: 'Speed Triple' },
      { id: nanoid(), label: 'Speed Twin', value: 'Speed Twin' },
      { id: nanoid(), label: 'Speed Twin 1200', value: 'Speed Twin 1200' },
      { id: nanoid(), label: 'Speed Twin 900', value: 'Speed Twin 900' },
      { id: nanoid(), label: 'Speedmaster', value: 'Speedmaster' },
      { id: nanoid(), label: 'Street Cup', value: 'Street Cup' },
      { id: nanoid(), label: 'Street Scrambler', value: 'Street Scrambler' },
      { id: nanoid(), label: 'Street Triple', value: 'Street Triple' },
      { id: nanoid(), label: 'Street Twin', value: 'Street Twin' },
      { id: nanoid(), label: 'Thunderbird', value: 'Thunderbird' },
      { id: nanoid(), label: 'Tiger', value: 'Tiger' },
      { id: nanoid(), label: 'Tiger 1200', value: 'Tiger 1200' },
      { id: nanoid(), label: 'Tiger 660', value: 'Tiger 660' },
      { id: nanoid(), label: 'Tiger 800', value: 'Tiger 800' },
      { id: nanoid(), label: 'Tiger 850', value: 'Tiger 850' },
      { id: nanoid(), label: 'Tiger 900', value: 'Tiger 900' },
      { id: nanoid(), label: 'Tiger Explorer', value: 'Tiger Explorer' },
      { id: nanoid(), label: 'Tiger Sport', value: 'Tiger Sport' },
      { id: nanoid(), label: 'Trident', value: 'Trident' },
    ],
  },
  {
    id: nanoid(),
    label: 'Trs',
    value: 'Trs',
    model: [],
  },
  {
    id: nanoid(),
    label: 'Ubco',
    value: 'Ubco',
    model: [
      { id: nanoid(), label: '2X2 Adventure', value: '2X2 Adventure' },
      { id: nanoid(), label: 'Adventure Bike', value: 'Adventure Bike' },
    ],
  },
  {
    id: nanoid(),
    label: 'Ubco',
    value: 'Ubco',
    model: [
      { id: nanoid(), label: 'Gear Up', value: 'Gear Up' },
      { id: nanoid(), label: 'Retro', value: 'Retro' },
    ],
  },
  {
    id: nanoid(),
    label: 'Vanderhall',
    value: 'Vanderhall',
    model: [
      { id: nanoid(), label: 'Carmel', value: 'Carmel' },
      { id: nanoid(), label: 'Venice', value: 'Venice' },
    ],
  },
  {
    id: nanoid(),
    label: 'Vespa',
    value: 'Vespa',
    model: [
      { id: nanoid(), label: 'Elettrica', value: 'Elettrica' },
      { id: nanoid(), label: 'Et2', value: 'Et2' },
      { id: nanoid(), label: 'Et4', value: 'Et4' },
      { id: nanoid(), label: 'Primavera', value: 'Primavera' },
      { id: nanoid(), label: 'Primavera Touring', value: 'Primavera Touring' },
      { id: nanoid(), label: 'Sei Giorni', value: 'Sei Giorni' },
    ],
  },
  {
    id: nanoid(),
    label: 'Victory',
    value: 'Victory',
    model: [
      { id: nanoid(), label: 'Arlen Ness', value: 'Arlen Ness' },
      { id: nanoid(), label: 'Gunner', value: 'Gunner' },
      { id: nanoid(), label: 'Hammer', value: 'Hammer' },
      { id: nanoid(), label: 'Judge', value: 'Judge' },
      { id: nanoid(), label: 'Octane', value: 'Octane' },
      { id: nanoid(), label: 'Touring Cruiser', value: 'Touring Cruiser' },
      { id: nanoid(), label: 'Vegas', value: 'Vegas' },
    ],
  },
  {
    id: nanoid(),
    label: 'Volcon',
    value: 'Volcon',
    model: [{ id: nanoid(), label: 'Kids Moto One', value: 'Kids Moto One' }],
  },
  {
    id: nanoid(),
    label: 'Yamaha',
    value: 'Yamaha',
    model: [
      { id: nanoid(), label: 'Apex', value: 'Apex' },
      { id: nanoid(), label: 'Blaster', value: 'Blaster' },
      { id: nanoid(), label: 'Civante', value: 'Civante' },
      { id: nanoid(), label: 'Crossconnect', value: 'Crossconnect' },
      { id: nanoid(), label: 'Crosscore', value: 'Crosscore' },
      { id: nanoid(), label: 'Majesty', value: 'Majesty' },
      { id: nanoid(), label: 'Niken', value: 'Niken' },
      { id: nanoid(), label: 'Raider', value: 'Raider' },
      { id: nanoid(), label: 'Roadliner', value: 'Roadliner' },
      { id: nanoid(), label: 'Sidewinder L', value: 'Sidewinder L' },
      { id: nanoid(), label: 'Star Eluder', value: 'Star Eluder' },
      { id: nanoid(), label: 'Star Venture', value: 'Star Venture' },
      { id: nanoid(), label: 'Stratoliner', value: 'Stratoliner' },
      { id: nanoid(), label: 'Stryker', value: 'Stryker' },
      { id: nanoid(), label: 'Super Tenere', value: 'Super Tenere' },
      { id: nanoid(), label: 'Tenere', value: 'Tenere' },
      { id: nanoid(), label: 'Tracer', value: 'Tracer' },
      { id: nanoid(), label: 'Venture', value: 'Venture' },
      { id: nanoid(), label: 'Waverunner Ex', value: 'Waverunner Ex' },
      { id: nanoid(), label: 'Waverunner Vx', value: 'Waverunner Vx' },
      { id: nanoid(), label: 'Wolverine Rmax2', value: 'Wolverine Rmax2' },
    ],
  },
  {
    id: nanoid(),
    label: 'Yamaha',
    value: 'Yamaha',
    model: [{ id: nanoid(), label: 'Lite', value: 'Lite' }],
  },
  {
    id: nanoid(),
    label: 'Ziggy',
    value: 'Ziggy',
    model: [],
  },
];

export const colorOptions = [
  { id: nanoid(), value: 'Black', label: 'Black' },
  { id: nanoid(), value: 'Gray', label: 'Gray' },
  { id: nanoid(), value: 'Red', label: 'Red' },
  { id: nanoid(), value: 'Yellow', label: 'Yellow' },
  { id: nanoid(), value: 'Purple', label: 'Purple' },
  { id: nanoid(), value: 'Orange', label: 'Orange' },
  { id: nanoid(), value: 'Silver', label: 'Silver' },
  { id: nanoid(), value: 'White', label: 'White' },
];

export const transOptions = [
  { id: nanoid(), value: 'Automatic', label: 'Automatic' },
  { id: nanoid(), value: 'CVT', label: 'CVT' },
  { id: nanoid(), value: 'Manual', label: 'Manual' },
];

export const driveOptions = [
  { id: nanoid(), value: '4WD', label: '4WD' },
  { id: nanoid(), value: 'AWD', label: 'AWD' },
  { id: nanoid(), value: 'FWD', label: 'FWD' },
  { id: nanoid(), value: 'RWD', label: 'RWD' },
];

export const engineOptions = [
  { id: nanoid(), value: '3', label: '3 Cylinder' },
  { id: nanoid(), value: '4', label: '4 Cylinder' },
  { id: nanoid(), value: '5', label: '5 Cylinder' },
  { id: nanoid(), value: '6', label: '6 Cylinder' },
  { id: nanoid(), value: '8', label: '8 Cylinder' },
  { id: nanoid(), value: '10', label: '10 Cylinder' },
  { id: nanoid(), value: '12', label: '12 Cylinder' },
];

export const bodyOptions = [
  { id: nanoid(), value: 'Car Van', label: 'Car Van' },
  { id: nanoid(), value: 'Cargo Van', label: 'Cargo Van' },
  { id: nanoid(), value: 'Chassis Cab', label: 'Chassis Cab' },
  { id: nanoid(), value: 'Combi', label: 'Combi' },
  { id: nanoid(), value: 'Commercial Wagon', label: 'Commercial Wagon' },
  { id: nanoid(), value: 'Convertible', label: 'Convertible' },
  { id: nanoid(), value: 'Coupe', label: 'Coupe' },
  { id: nanoid(), value: 'Cutaway', label: 'Cutaway' },
  { id: nanoid(), value: 'Hatchback', label: 'Hatchback' },
  { id: nanoid(), value: 'Micro Car', label: 'Micro Car' },
  { id: nanoid(), value: 'Mini Mpv', label: 'Mini Mpv' },
  { id: nanoid(), value: 'Minivan', label: 'Minivan' },
  { id: nanoid(), value: 'Passenger Van', label: 'Passenger Van' },
  { id: nanoid(), value: 'Pickup', label: 'Pickup' },
  { id: nanoid(), value: 'Sedan', label: 'Sedan' },
  { id: nanoid(), value: 'SUV', label: 'SUV/Crossover' },
  { id: nanoid(), value: 'Targa', label: 'Targa' },
  { id: nanoid(), value: 'Van', label: 'Van' },
  { id: nanoid(), value: 'Wagon', label: 'Wagon' },
];

export const fuelOptions = [
  { id: nanoid(), value: 'Biodiesel', label: 'Biodiesel' },
  {
    id: nanoid(),
    value: 'Compressed Natural Gas',
    label: 'Compressed Natural Gas',
  },
  {
    id: nanoid(),
    value: 'Compressed Natural Gas/Lpg',
    label: 'Compressed Natural Gas / Lpg',
  },
  {
    id: nanoid(),
    value: 'Compressed Natural Gas / Unleaded',
    label: 'Compressed Natural Gas / Unleaded',
  },
  { id: nanoid(), value: 'Diesel', label: 'Diesel' },
  { id: nanoid(), value: 'E85', label: 'E85' },
  {
    id: nanoid(),
    value: 'E85 / Premium Unleaded',
    label: 'E85 / Premium Unleaded',
  },
  { id: nanoid(), value: 'E85 / Unleaded', label: 'E85 / Unleaded' },
  { id: nanoid(), value: 'Electric', label: 'Electric' },
  { id: nanoid(), value: 'Electric / E85', label: 'Electric / E85' },
  { id: nanoid(), value: 'Electric / Hydrogen', label: 'Electric / Hydrogen' },
  {
    id: nanoid(),
    value: 'Electric / Premium Unleaded',
    label: 'Electric / Premium Unleaded',
  },
  { id: nanoid(), value: 'Electric / Unleaded', label: 'Electric / Unleaded' },
  { id: nanoid(), value: 'EV', label: 'EV' },
  { id: nanoid(), value: 'Hybrid', label: 'Hybrid' },
  { id: nanoid(), value: 'Hydrogen', label: 'Hydrogen' },
  { id: nanoid(), value: 'M85 / Unleaded', label: 'M85 / Unleaded' },
  { id: nanoid(), value: 'Premium Unleaded', label: 'Premium Unleaded' },
  {
    id: nanoid(),
    value: 'Premium Unleaded / E85',
    label: 'Premium Unleaded / E85',
  },
  {
    id: nanoid(),
    value: 'Premium Unleaded / Natural Gas',
    label: 'Premium Unleaded / Natural Gas',
  },
  {
    id: nanoid(),
    value: 'Premium Unleaded / Unleaded',
    label: 'Premium Unleaded / Unleaded',
  },
  { id: nanoid(), value: 'Standard', label: 'Standard' },
  { id: nanoid(), value: 'Unleaded', label: 'Unleaded' },
  { id: nanoid(), value: 'Unleaded / E85', label: 'Unleaded / E85' },
  { id: nanoid(), value: 'Unleaded / Electric', label: 'Unleaded / Electric' },
  {
    id: nanoid(),
    value: 'Unleaded / Premium Unleaded',
    label: 'Unleaded / Premium Unleaded',
  },
];

export const premiumFeaturesOptions = [
  { id: nanoid(), value: '3rd Row Seating', label: '3rd Row Seating' },
  {
    id: nanoid(),
    value: 'Adaptive Cruise Control',
    label: 'Adaptive Cruise Control',
  },
  { id: nanoid(), value: 'Alloy Wheels', label: 'Alloy Wheels' },
  {
    id: nanoid(),
    value: 'Anti Collision System',
    label: 'Anti Collision System',
  },
  {
    id: nanoid(),
    value: 'Blind Spot Monitoring',
    label: 'Blind Spot Monitoring',
  },
  { id: nanoid(), value: 'Brake Assist', label: 'Brake Assist' },
  { id: nanoid(), value: 'CarPlay', label: 'CarPlay' },
  { id: nanoid(), value: 'Convertible Roof', label: 'Convertible Roof' },
  { id: nanoid(), value: 'Cruise Control', label: 'Cruise Control' },
  { id: nanoid(), value: 'Fog Lights', label: 'Fog Lights' },
  { id: nanoid(), value: 'Heated Seats', label: 'Heated Seats' },
  {
    id: nanoid(),
    value: 'Keyless Start/Remote Engine Start',
    label: 'Keyless Start/Remote Engine Start',
  },
  { id: nanoid(), value: 'Lane Keep Assist', label: 'Lane Keep Assist' },
  { id: nanoid(), value: 'Leather Seats', label: 'Leather Seats' },
  { id: nanoid(), value: 'Navigation', label: 'Navigation' },
  { id: nanoid(), value: 'Parking Assistance', label: 'Parking Assistance' },
  { id: nanoid(), value: 'Parking Sensor', label: 'Parking Sensor' },
  { id: nanoid(), value: 'Power Closing Doors', label: 'Power Closing Doors' },
  {
    id: nanoid(),
    value: 'Power Closing Liftgate',
    label: 'Power Closing Liftgate',
  },
  { id: nanoid(), value: 'Premium Audio', label: 'Premium Audio' },
  { id: nanoid(), value: 'Premium Wheels', label: 'Premium Wheels' },
  {
    id: nanoid(),
    value: 'Steering Wheel Controls',
    label: 'Steering Wheel Controls',
  },
  { id: nanoid(), value: 'Sun Roof/Moon Roof', label: 'Sun Roof/Moon Roof' },
  { id: nanoid(), value: 'Voice Recognision', label: 'Voice Recognision' },
];

export const perPageOptions = [
  { id: nanoid(), value: 12, label: 12 },
  { id: nanoid(), value: 24, label: 24 },
  { id: nanoid(), value: 36, label: 36 },
  { id: nanoid(), value: 48, label: 48 },
  { id: nanoid(), value: 96, label: 96 },
];

export const sortByOptions = [
  { id: nanoid(), value: 'Closest to Me', label: 'Closest to Me' },
  // { id: nanoid(), value: 'Lowest Mileage', label: 'Lowest Mileage' },
  {
    id: nanoid(),
    value: 'New Model to Old Model',
    label: 'New Model to Old Model',
  },
  {
    id: nanoid(),
    value: 'Old Model to New Model',
    label: 'Old Model to New Model',
  },
  {
    id: nanoid(),
    value: 'High Mileage to Low Mileage',
    label: 'High Mileage to Low Mileage',
  },
  {
    id: nanoid(),
    value: 'Low Mileage to High Mileage',
    label: 'Low Mileage to High Mileage',
  },
  { id: nanoid(), value: 'Price (low-high)', label: 'Price (low-high)' },
  { id: nanoid(), value: 'Price (high-low)', label: 'Price (high-low)' },
  { id: nanoid(), value: 'Recently Posted', label: 'Recently Posted' },
];

export const noResultsMessage =
  'No search results found. Be the first to <a href="/submit-listing/details/" class="add-listing-btn">add a listing</a> in this category!';
export const endOfListMessage =
  'Looks like you’ve cruised to the end of the list! To find your perfect ride, try fine-tuning your search using the filters. Happy hunting on FinditZ! 🚗✨';
